import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PTESlider from "../components/Frontend/Sliders/PTESlider"
import API from "../api";
import { store } from "store/index";
import { setAlert } from "action/index";
import { getCountryForTimezone } from "countries-and-timezones";
import BannerSection from "components/PublicPagesReusable/BannerSection";
import SkillAssment from "components/PublicPagesReusable/SkillAssment";
import WhyChoose from "components/PublicPagesReusable/WhyChoose";
import BannerHeader from "components/PublicPagesReusable/BannerHeader";
import bannerImage from "../assets/images/public-pages/New-Public-banner.webp"
import '../assets/css/public-pages.css'
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import Immigration from "../assets/images/public-pages/immigration-test.svg";
import Speaking from "../assets/images/public-pages/core-speaking.svg";
import Writing from "../assets/images/public-pages/core-writing.svg";
import Reading from "../assets/images/public-pages/core-reading.svg"
import Listening from "../assets/images/public-pages/core-listening.svg"
import Report from "../assets/images/public-pages/report.svg";
import CheckList from "../assets/images/public-pages/check-list.svg";
import Filter from "../assets/images/public-pages/filter.svg"
import Reward from "../assets/images/public-pages/reward.svg"
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import Frame1 from "../assets/images/public-pages/Frame1.svg"
import Frame2 from "../assets/images/public-pages/Frame2.svg"
import Frame3 from "../assets/images/public-pages/Frame3.svg"
import Frame4 from "../assets/images/public-pages/Frame4.svg"
import Frame5 from "../assets/images/public-pages/Frame5.svg";
import Frame6 from "../assets/images/public-pages/Frame6.svg";
import Frame7 from "../assets/images/public-pages/Frame7.svg";
import Frame8 from "../assets/images/public-pages/Frame8.svg";
import Frame9 from "../assets/images/public-pages/Frame9.svg";
import Frame10 from "../assets/images/public-pages/Frame10.svg";
import Frame11 from "../assets/images/public-pages/Frame11.svg";
import Frame12 from "../assets/images/public-pages/Frame12.svg";
import Frame13 from "../assets/images/public-pages/Frame13.svg";
import Frame14 from "../assets/images/public-pages/Frame14.svg";
import Frame15 from "../assets/images/public-pages/Frame15.svg";
import Frame16 from "../assets/images/public-pages/Frame16.svg";
import Frame17 from "../assets/images/public-pages/Frame17.svg";
import Frame18 from "../assets/images/public-pages/Frame18.svg";
import Frame19 from "../assets/images/public-pages/Frame19.svg";
import ClbCard from "components/PublicPagesReusable/ClbCard";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import ComparisonSection from "components/PublicPagesReusable/ComparisionSection";
import ImmigrationSection from "components/PublicPagesReusable/ImmigrationSection";
import TestSection from "components/PublicPagesReusable/TestSection";
import AdvantageSection from "components/PublicPagesReusable/AdvantageSection";
import PricingSection from "components/PublicPagesReusable/PricingSection";
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import PteAppBanner from "components/PublicPagesReusable/PteAppBanner";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import { PricingCard } from "./Home";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
// import RightArrowIcon from "../assets/images/web-new-images/right-arrow-black.svg";


const PteCore = () => {
  const [isActive, setIsActive] = useState(false);
  const [corePlans, setCorePlans] = useState([]);
  const [country, setCountry] = useState("AU");
  const whyChooseSectionHeader = () => {
    return (
      <h2 className="primary-heading dark-blue-color text-center fw-700">
        <span className="wpl-badge gold-badge text-white">
          WHY CHOOSE THE PTE EXAM?
        </span>
        <br className="d-block" />5 KEY ADVANTAGES
        <br className="d-block" />OVER OTHER TESTS
      </h2>
    )
  }
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    getPackages();
  }, []);

  const handleClick = () => {
    setIsActive((prevState) => !prevState);
  };
 const getPackages = () => {
    const country = getCountryForTimezone(
      Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    let countryId = "AU";
    if (country && country.id) {
      countryId = country.id;
    }
    const url =
      import.meta.env.VITE_URL_ALT +
      "/api/v2/getPackagesAll?countryId=" +
      countryId;
    API({
      url: url,
      method: "GET",
    }).then((res) => {
      if (res.status === 200) {
        const data = res.data;
        setCorePlans(data.core);
        setCountry(res.data.country);
      } else {
        store.dispatch(
          setAlert({ flag: true, type: 2, message: "Something went wrong." })
        );
      }
    });
  };

  const CardSlider = {
    adaptiveHeight: true,
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
  };


  const subTitleSection = () => {
    return (<p className="sub-title text-center FS16FW500 white">
      Join thousands of successful candidates who've earned their required <br /> scores with our proven PTE Core preparation system.
    </p>)
  }

  const heroDescriptionSection = () => {
    return (<p className="sub-title text-center FS16FW500 FS16FW500" style={{color:'#525252'}}>
      Enhance your English skills with our PTE Core Online Training, designed specifically for Canadian immigration <br />
      success. With personalized strategies and AI-powered PTE Core practice material, achieve your required scores <br />
      faster than ever before!
    </p>)
  }

  const bannerTitle = () => {
    return (
      <h1 className="FS56FW500 top-section-text">
        Achieve <span className="text-success">Your PTE Core</span> Target Score &
        Secure Canadian Immigration Success
      </h1>
    )
  }

  const blueBoxText = () => {
    return (<div className="light-blue-box">
      Enhance your English skills with our PTE Core Online Training, designed specifically for <br />  Canadian immigration success. With personalized strategies and AI-powered PTE Core<br />  practice material, achieve your required scores faster than ever before!
    </div>)
  }

  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text">Achieve <span className="text-success fw-600">Your PTE Core</span> Target
          <br />
          Score & Secure Canadian <br /> Immigration Success
      </h1>
    );
  };
  const heroData = {
    badge: "50,000+ Students' Success Stories",
    title: heroWorkTitle,
    subtitle: "Join 50,000+ successful candidates who've achieved their target scores<br/> with our proven method.",
    btn_prepration: { text: "Start Your PTE Core Preparation", onClick: () => window.location.href = '/auth/register' },
    btn_outline: { text: "Free Mock Test", variant: "outline", onClick: () => window.location.href = '/auth/register' },
    users: [
      "/images/web-new-images/new-content-slider/User-01.svg",
      "/images/web-new-images/new-content-slider/User-02.svg",
      "/images/web-new-images/new-content-slider/User-03.svg",
      "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
    ],
    trustText: "Trusted by 50,000+ students'",
    profile: {
      image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
      stats: [
        { value: "50K+", label: "STUDENTS" },
        { value: "95%", label: "SUCCESS RATE" },
        { value: "10+", label: "LOCATIONS" }
      ]
    },
    bottomStats: [
      { value: "8",highlight:'+', label: "Years of PTE Expertise" },
      { value: "30", highlight:'+', label: "Countries Served" },
      { value: "/5", highlight:'4.8', label: "Rated PTE Practice App" },
      { value: "-Powered", highlight:'AI', label: "Scoring Engine" }
    ]
  };

  const skillData = [
    {
      id: 1,
      title: "Speaking",
      description: "Fluency, pronunciation and coherence",
      image: "/images/web-new-images/icons/w-speak-icon.svg",
      color: "#c42fed"
    },
    {
      id: 2,
      title: "Writing",
      description: "Essay writing, sumarizing information",
      image: "/images/web-new-images/icons/w-write-icon.svg",
      color: "#6366F1"
    },
    {
      id: 3,
      title: "Reading",
      description: "Comprehesion, vocabulary, text analysis",
      image: "/images/web-new-images/icons/w-reading-icon.svg",
      color: "#8B5CF6"
    },
    {
      id: 4,
      title: "Listening",
      description: "Understanding spoken English, main ideas",
      image: "/images/web-new-images/icons/w-listen-icon.svg",
      color: "#7E22CE"
    }
  ];

  const images = [{
      src: Frame1,
      alt: "score-1",
    },
    {
      src: Frame2,
      alt: "score-2",
    },
    {
      src: Frame3,
      alt: "score-3",
    },
    {
      src: Frame4,
      alt: "score-4",
    },
    {
      src: Frame5,
      alt: "score-5",
    },
    {
      src: Frame6,
      alt: "score-6",
    },{
      src: Frame7,
      alt: "score-7",
    },
    {
      src: Frame8,
      alt: "score-8",
    },
    {
      src: Frame9,
      alt: "score-9",
    },
    {
      src: Frame10,
      alt: "score-10",
    },
    {
      src: Frame11,
      alt: "score-11",
    },
    {
      src: Frame12,
      alt: "score-12",
    },
    {
      src: Frame13,
      alt: "score-13",
    },
    {
      src: Frame14,
      alt: "score-14",
    },{
      src: Frame15,
      alt: "score-15",
    },
    {
      src: Frame16,
      alt: "score-16",
    },
    {
      src: Frame17,
      alt: "score-17",
    },
    {
      src: Frame18,
      alt: "score-18",
    },
    {
      src: Frame19,
      alt: "score-19",
    }
  ];
  const lifestyleCards = [
    {
      title: "Speaking",
      text: "Pronunciation, fluency, clarity",
      color:"transparent",
      hoverColor: '#007AFF',
      img: Speaking,
      borderColor:'rgba(255, 255, 255, 0.24)'
    },
    {
      title: "Writing",
      text: "Essay writing, summarizing information",
      color:"transparent",
      hoverColor: "#FF3B30",
      img: Writing,
      borderColor:'rgba(255, 255, 255, 0.24)'
    },
    {
      title: "Reading",
      text: "Comprehension, analysis, vocabulary",
      color:"transparent",
      hoverColor: "#FFCC00",
      img: Reading,
      borderColor:'rgba(255, 255, 255, 0.24)'
    },
    {
      title: "Listening",
      text: "Understanding spoken English, note-taking",
      color:"transparent",
      hoverColor: "#34C759",
      img: Listening,
      borderColor:'rgba(255, 255, 255, 0.24)'
    },
  ];
  const styleCards = [
    {
      title: "Faster Results",
      text: "Scores delivered in 48 hours vs. 13+ days for IELTS and 5-8 days for CELPIP",
      color: "#141414",
      img: Report,
      borderColor:'rgba(255, 255, 255, 0.24)',
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    },
    {
      title: "AI-Powered Scoring",
      text: "Eliminates human bias with consistent, algorithm-based evaluation",
      color: "#141414",
      img: CheckList,
      borderColor:'rgba(255, 255, 255, 0.24)',
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    },
    {
      title: "Ultimate Convenience",
      text: "Year-round testing with flexible scheduling and worldwide test centers",
      color: "#141414",
      img: Filter,
      borderColor:'rgba(255, 255, 255, 0.24)',
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    },
    {
      title: "Unlimited Attempts",
      text: "Retake as needed with only a 5-day waiting period between tests",
      color: "#141414",
      img: Reward,
      borderColor:'rgba(255, 255, 255, 0.24)',
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    },
  ];
  const skillAreaTitle = () => {
    return (
      <h3 className="top-section-text mb-4 white FS40FW600">
        The 2-Hour Computer-Based Test Evaluates Four <span className="text-success FS40FW600">Essential Skill Areas</span>
      </h3>
    )
  }
  const skillAreaTitle2 = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        <span className="text-success FS40FW600">Why Choose The PTE Core? </span><br />
        5 Key Advantages Over<br/> Other Tests
      </h3>
    )
  }
  const contentSection = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        <span className="text-success FS40FW600">What Is PTE Core? </span><br />
        The Official Canadian Immigration Test
      </h3>
    )
  }

  const comparisionTopText = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        PTE Core vs. IELTS vs. CELPIP  <br />
        <span className="text-success FS40FW600">Side-by-Side Comparison </span>
      </h3>
    )
  }
  const comparisionData = [
    {
      title: "IELTS",
      subtitle: "Traditional Testing Format",
      features: [
        { label: "RESULTS TIMEFRAME", value: "13–15 days" },
        { label: "SCORING METHOD", value: "Human examiners" },
        { label: "TEST AVAILABILITY", value: "Limited seats" },
        { label: "DIGITAL FORMAT", value: "Paper & digital options" },
      ],
      cta: "Learn More",
      ctaLink: "/ielts-coaching-parramatta",
    },
    {
      title: "PTE Core",
      subtitle: "The streamlined, AI-powered test for faster results.",
      recommended: true,
      features: [
        { label: "RESULTS TIMEFRAME", value: "48 hours" },
        { label: "SCORING METHOD", value: "AI-driven (objective)" },
        { label: "TEST AVAILABILITY", value: "Year-around, flexible" },
        { label: "DIGITAL FORMAT", value: "Fully digital" },
      ],
      cta: "Start Your Preparation Now",
      ctaLink: "/auth/register",
    },
    {
      title: "CELPIP",
      subtitle: "Traditional Testing Format",
      features: [
        { label: "RESULTS TIMEFRAME", value: "5–8 days" },
        { label: "SCORING METHOD", value: "Mixed evaluation" },
        { label: "TEST AVAILABILITY", value: "Select centres only" },
        { label: "DIGITAL FORMAT", value: "Computer-based only" },
      ],
      cta: "Learn More",
      ctaLink: "/contact",
    },
  ];
  const immigrationData = {
    title: "PTE Core Essential ",
    highlight: "For Canadian Immigration Success",
    description:
      "Meeting language requirements is the #1 factor for successful Express Entry applications",

    buttonText: "Begin Your Test Preparation",
    buttonLink:'/auth/register',
    rightText:
      "Scoring well in PTE Core is a crucial step for Canadian immigration. The test directly impacts your:",

    benefits: [
      "Comprehensive Ranking System (CRS) points for Express Entry",
      "Provincial Nominee Program eligibility",
      "Study and work permit applications",
    ],

    cards: [
      {
        title: "Express Entry",
        subtitle: "Federal Skilled Worker",
        badge: "CLB 7",
        target: "60+",
      },
      {
        title: "Canadian Experience",
        subtitle: "Class (CEC)",
        badge: "CLB 7–9",
        target: "60–75+",
        active: true,
      },
      {
        title: "Provincial Nominee",
        subtitle: "Program (PNP)",
        badge: "Varies",
        target: "Variable",
      },
      {
        title: "Study Permits",
        subtitle: "Student Direct Stream",
        badge: "Based on Program",
        target: "50+",
      },
    ],
  };

  const testData = {
    title: "Master All Four",
    highlight: "PTE Core",
    subtitle: "Test Sections",
    description: 'Our specialized PTE Core Course helps you excel in every component of the PTE Core exam:',
    tabs: [
      {
        label: "Speaking",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6673 10V10.8333C16.6673 14.5152 13.6825 17.5 10.0007 17.5C6.31875 17.5 3.33398 14.5152 3.33398 10.8333V10M10.0007 14.1667C8.1597 14.1667 6.66732 12.6743 6.66732 10.8333V5.83333C6.66732 3.99238 8.1597 2.5 10.0007 2.5C11.8416 2.5 13.334 3.99238 13.334 5.83333V10.8333C13.334 12.6743 11.8416 14.1667 10.0007 14.1667Z" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        content: {
          leftTitle: "What It Tests",
          leftPoints: [
            "Clear pronunciation and natural intonation",
            "Ability to repeat sentences and read text aloud",
            "Skills in retelling lectures and answering questions",
          ],
          rightTitle: "Our Approach",
          rightPoints: [
            "Pronunciation improvement using AI feedback",
            "Confidence-building through recorded practice sessions",
            "PTE Core practice material for the most challenging speaking tasks",
          ],
        },
      },
      {
        label: "Writing",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2010_471)">
            <path d="M10.8346 4.99987L5.41949 6.0829C5.11699 6.1434 4.96574 6.17365 4.84257 6.24721C4.73368 6.31224 4.64107 6.40127 4.5718 6.50751C4.49344 6.62768 4.45725 6.77762 4.38487 7.07749L1.66797 18.3332M1.66797 18.3332L12.9237 15.6163C13.2236 15.5439 13.3735 15.5077 13.4937 15.4294C13.5999 15.3601 13.6889 15.2675 13.754 15.1586C13.8275 15.0354 13.8578 14.8842 13.9183 14.5817L15.0013 9.16654M1.66797 18.3332L7.98964 12.0115M17.3918 6.55707L13.4441 2.60935C13.1141 2.27934 12.9491 2.11433 12.7588 2.0525C12.5914 1.99812 12.4112 1.99812 12.2438 2.05251C12.0535 2.11433 11.8885 2.27934 11.5585 2.60935L10.9441 3.22373C10.6141 3.55375 10.4491 3.71875 10.3873 3.90903C10.3329 4.0764 10.3329 4.25669 10.3873 4.42406C10.4491 4.61433 10.6141 4.77934 10.9441 5.10935L14.8918 9.05707C15.2218 9.38708 15.3868 9.55209 15.5771 9.61391C15.7445 9.66829 15.9248 9.66829 16.0922 9.61391C16.2824 9.55209 16.4474 9.38708 16.7774 9.05706L17.3918 8.44268C17.7218 8.11267 17.8868 7.94766 17.9487 7.75739C18.0031 7.59002 18.0031 7.40973 17.9487 7.24236C17.8868 7.05209 17.7218 6.88708 17.3918 6.55707ZM9.16797 9.16654C10.0884 9.16654 10.8346 9.91273 10.8346 10.8332C10.8346 11.7537 10.0884 12.4999 9.16797 12.4999C8.24749 12.4999 7.5013 11.7537 7.5013 10.8332C7.5013 9.91273 8.24749 9.16654 9.16797 9.16654Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
          </g>
        </svg>,
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Essay writing on general topics", "Summarizing written information", "Grammar, vocabulary, and coherence"],
          rightTitle: "Our Approach",
          rightPoints: ["Proven templates for essay structure and organization", "PTE Core preparation techniques for concise summarizing", "Grammar and vocabulary enhancement for higher scores "],
        },
      },
      {
        label: "Reading",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.0013 17.5L9.91792 17.3749C9.33905 16.5066 9.04962 16.0725 8.66722 15.7582C8.32868 15.4799 7.93861 15.2712 7.51931 15.1438C7.04568 15 6.52389 15 5.48032 15H4.33464C3.40121 15 2.9345 15 2.57798 14.8183C2.26438 14.6586 2.00941 14.4036 1.84962 14.09C1.66797 13.7335 1.66797 13.2668 1.66797 12.3333V5.16667C1.66797 4.23325 1.66797 3.76654 1.84962 3.41002C2.00941 3.09641 2.26438 2.84144 2.57798 2.68166C2.9345 2.5 3.40121 2.5 4.33464 2.5H4.66797C6.53481 2.5 7.46823 2.5 8.18127 2.86331C8.80848 3.18289 9.31841 3.69282 9.63799 4.32003C10.0013 5.03307 10.0013 5.96649 10.0013 7.83333M10.0013 17.5V7.83333M10.0013 17.5L10.0847 17.3749C10.6635 16.5066 10.953 16.0725 11.3354 15.7582C11.6739 15.4799 12.064 15.2712 12.4833 15.1438C12.9569 15 13.4787 15 14.5223 15H15.668C16.6014 15 17.0681 15 17.4246 14.8183C17.7382 14.6586 17.9932 14.4036 18.153 14.09C18.3346 13.7335 18.3346 13.2668 18.3346 12.3333V5.16667C18.3346 4.23325 18.3346 3.76654 18.153 3.41002C17.9932 3.09641 17.7382 2.84144 17.4246 2.68166C17.0681 2.5 16.6014 2.5 15.668 2.5H15.3346C13.4678 2.5 12.5344 2.5 11.8213 2.86331C11.1941 3.18289 10.6842 3.69282 10.3646 4.32003C10.0013 5.03307 10.0013 5.96649 10.0013 7.83333" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        ,
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Comprehension of academic and everyday texts", "Ability to identify main ideas and supporting details", "Vocabulary knowledge and text organization skills"],
          rightTitle: "Our Approach",
          rightPoints: ["Time management strategies for complex passages", "PTE core Academic Practice Tests for reordering paragraphs and fill-in-blanks", "Vocabulary building focused on commonly tested topics"],
        },
      },
      {
        label: "Listening",
        icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.5 15V10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10V15M4.58333 17.5C3.43274 17.5 2.5 16.5673 2.5 15.4167V13.75C2.5 12.5994 3.43274 11.6667 4.58333 11.6667C5.73393 11.6667 6.66667 12.5994 6.66667 13.75V15.4167C6.66667 16.5673 5.73393 17.5 4.58333 17.5ZM15.4167 17.5C14.2661 17.5 13.3333 16.5673 13.3333 15.4167V13.75C13.3333 12.5994 14.2661 11.6667 15.4167 11.6667C16.5673 11.6667 17.5 12.5994 17.5 13.75V15.4167C17.5 16.5673 16.5673 17.5 15.4167 17.5Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Understanding different accents and speech patterns", "Following spoken directions and identifying main ideas", "Note-taking from lectures and conversations"],
          rightTitle: "Our Approach",
          rightPoints: ["Strategic listening exercises with authentic Canadian accents", "PTE Core Practice material with all question types including multiple-choice and fill-in-blanks", "Techniques for identifying key information in fast-paced recordings"],
        },
      },
    ],
    cta: "Enroll in Our Preparation Program",
    ctaLink: "/auth/register",
  };

  const advantageSectionData = {
    titleTop: "The Language Academy Advantage",
    titleMain: "Complete PTE Core Coaching Method",

    highlightBox:
      "91% of our students achieve their target scores within two attempts",

    description:
      "At Language Academy, we've developed a comprehensive PTE Core Course combining technology, expert instruction, and proven methodologies.",

    buttonText: "Booking Your Preparation Session",

    timeline: [
      {
        number: 1,
        title: "PTE Core Practice Material",
        desc: "Experience the actual PTE Core test environment with our simulation technology that mirrors the real exam algorithms.",
      },
      {
        number: 2,
        title: "Detailed Performance Analytics",
        desc: "Receive comprehensive score breakdowns showing exactly where you're losing points and how to improve with our PTE Core Practice Website.",
      },
      {
        number: 3,
        title: "Expert PTE Core Preparation Guidance",
        desc: "Learn from tutors who specialize in PTE Core Online Training",
      },
      {
        number: 4,
        title: "PTE Core Practice Materials & Strategies",
        desc: "Apply our time-tested PTE Core resources specifically designed to maximize scores",
      },
    ],
  };

  const silverOneMonth = corePlans.find((p) => p.is_gold === 0 && p.duration === 1);
  const goldOneMonth = corePlans.find((p) => p.is_gold === 1 && p.duration === 1);
  const currencyPrefix = country === "IN" ? "₹" : "$";
  const silverPrice = silverOneMonth ? `${currencyPrefix}${silverOneMonth.price}` : "$29";
  const goldPrice = goldOneMonth ? `${currencyPrefix}${goldOneMonth.price}` : "$39";

  const pricingSectionData = {
    title: "Start Your",
    highlight: "PTE Core",
    subtitle: "Preparation Journey Today",
    note: `Choose your preparation package, starting from ${silverPrice}`,

    plans: [
      {
        name: "Silver",
        price: silverPrice,
        features: [
          { text: "Unlimited AI scoring for all question types", active: true },
          { text: "Full access to the exam questions", active: true },
          { text: "Access to latest templates and prediction files", active: true },
          { text: "Unlimited sectional mock tests with scoring", active: true },
          { text: "Unlimited full mock tests with scoring", active: true },
          { text: "Unlimited comprehensive mock tests with scoring", active: true },
          { text: "Access to reading explanation videos", active: false },
          { text: "Full access to premium strategy videos", active: false },
          { text: "Full access to the detailed video course", active: false },
        ],
        button: "Enroll Now",
      },
      {
        name: "Gold",
        price: goldPrice,
        badge: "BEST SELLER",
        features: [
          { text: "Unlimited AI scoring for all question types", active: true },
          { text: "Full access to the exam questions", active: true },
          { text: "Access to latest templates and prediction files", active: true },
          { text: "Unlimited sectional mock tests with scoring", active: true },
          { text: "Unlimited full mock tests with scoring", active: true },
          { text: "Unlimited comprehensive mock tests with scoring", active: true },
          { text: "Access to reading explanation videos", active: true },
          { text: "Full access to premium strategy videos", active: true },
          { text: "Full access to the detailed video course", active: true },
        ],
        button: "Enroll Now",
      },
      {
        name: "Online Coaching",
        badge: "MOST POPULAR",
        highlightCard: true,
        description:
          "Get the ultimate preparation with live expert guidance.",
        features: [
          {
            title: "Live Virtual Classes",
            desc: "Join expert-led sessions focusing on each component of the exam",
          },
          {
            title: "Personalized Feedback",
            desc: "Receive detailed analysis of your performance",
          },
          {
            title: "Direct Trainer Access",
            desc: "Get your questions answered directly",
          },
          {
            title: "Priority Support",
            desc: "Fast-track assistance whenever needed",
          },
        ],
        button: "Enroll Now",
      },
    ],
  };

  const faqQuestions = [
    {
      question: "How many PTE Core practice tests should I take for optimal preparation?",
      answer: "We recommend taking at least three complete PTE core Academic Practice Tests using our platform."
    },
    {
      question: "What is the PTE Core requirement for Canadian immigration?",
      answer: "Requirements vary based on immigration programs, consult your program's specific guidelines for score thresholds. Express Entry typically requires scores equivalent to CLB 7-9 depending on your program category."
    },
    {
      question: "What is the duration of a PTE Core mock test?",
      answer: "Each mock test takes approximately 2 hours, mirroring the actual exam."
    },
    {
      question: "How is PTE Core different from other English tests?",
      answer: "Unlike IELTS and CELPIP, PTE Core uses AI scoring for unbiased results and delivers scores within 48 hours. The test is fully digital and offers more flexible scheduling options."
    },
    {
      question: "Do you offer personalized PTE Core preparation coaching?",
      answer: "Yes, our PTE Core Online Training experts provide personalized feedback and PTE Core Course sessions with comprehensive PTE Core resources."
    },
    {
      question: "How quickly can I improve my score with your PTE Core preparation?",
      answer: "Most students see significant improvement within 2-3 weeks of dedicated practice with our PTE Core Practice Website and Free Online PTE Core Practice platform."
    },
    // {
    //   question: "Is there a limit to how many times I can take PTE Core?",
    //   answer: "No, you can take the test as many times as needed, with only a 5-day waiting period between attempts."
    // },
  ];

  const sliderList = {
    title: "What Our <span>Students Say</span>",
    subtitle: "Real success stories from our learners",

    settings: {
      slidesPerView: 3,
      spaceBetween: 20,
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    },

    items: [
      {
        id: 1,
        name: "Gagan Brar",
        location: "Australia",
        description:
          "I had a great experience at language academy and scored 8 bands in each. Roopali was an amazing tutor. She kept in touch with me right up until I got my results and supported me the whole way. Her lessons really helped me improve, especially in Writing and Speaking. I highly recommend it!",
        image: "/images/web-new-images/new-content-slider/gagan-brar.svg",
      },
       {
        id: 2,
        name: "Ushna Noor",
        location: "Lahore, Pakistan",
        description:
          "LA academy made PTE preparation much clearer and less stressful for me. The study material was up to date, and the strategies shared by Roopali for speaking and writing were particularly helpful. I liked how Roopali explained everything step by step, which made it easier to practise independently. It’s a great option for anyone looking for focused and flexible PTE preparation.",
        image: "/images/web-new-images/new-content-slider/ushna-noor.svg",
      },
      {
        id: 3,
        name: "CeMas Poojas",
        location: "Cabadbaran, Agusan del Norte",
        description:
          "I would like to express my sincere gratitude to LA Academy for their outstanding support and guidance during my PTE preparation. I just received my results today, and I am excited to share that I achieved an overall score of 80! A special thank you to Ma'am Sana and the entire team for your dedication and encouragement. Your efforts truly made a difference in my success. I highly recommend LA Academy to anyone looking to excel in their language proficiency tests!",
        image: "/images/web-new-images/new-content-slider/ceemas-poojas.svg",
      },
      {
        id: 4,
        name: "Riddhi Patel",
        location: "Rajkot, Gujarat",
        description:
          "I just got 4 online one on one classes with vishika. She is really good in understanding the dilemma of the students, and suggests the tips, tricks and ideas according to that. I got 81 overall score with 7 each in two modules and 8 each in other modules. I am really happy to study with a language academy, and especially with vishika. Thank you so much for making my journey easier…….",
        image: "/images/web-new-images/new-content-slider/riddhi-patel.svg",
      },
      {
        id: 5,
        name: "Nellam Kumari",
        location: "Australia",
        description:
          "The LA website is one of the best websites to practice and get real time feedback as well. The mock tests are realistic and practice questions are segregated by level of difficulty. I prepared mostly by watching Varun's videos on youtube and practicing on the website and got a 90 score. I also had a one on one session with Navneet Kaur from LA to get my mock tests and approach reviewed. She had been very helpful and responsive in addressing my queries. Thanks a lot team!",
        image: "/images/web-new-images/new-content-slider/neelam-kumari.svg",
      },
      {
        id: 6,
        name: "Liza Liza",
        location: "Brisbane, Queensland, Australia",
        description:
          "I’m incredibly grateful to LA Academy for helping me achieve my desired PTE score! The guidance, strategies, and constant support from the trainers made a huge difference in my preparation. The practice materials were up-to-date and very similar to the actual exam. What I appreciated most was the personal attention and honest feedback, which helped me improve my weak areas quickly. Thank you LA Academy for your dedication and for helping me reach my goal. Highly recommend to anyone serious about getting their target PTE score!",
        image: "/images/web-new-images/new-content-slider/liza.svg",
      },
      {
        id: 7,
        name: "Arvinder Kaur Rai",
        location: "Australia",
        description:
          "Hi its arvinder, I am currently living in saskatoon, canada. I gave my pte exam and got my desired scores. I highly recommend everyone please join language academy for getting desired scores. They are offering online classes as well as per your schedule. The most positive point is that the staff is really helpful. Specially mam ridhima, shivani and sana",
        image: "/images/web-new-images/new-content-slider/aravinder-kaur-rai.svg",
      },
      {
        id: 8,
        name: "Shreya Pokhrel",
        location: "Jhapa, Nepal",
        description:
          "I would highly recommend LA academy. I was able to secure 8 within 2 weeks of time. They are always willing to help you at any time. Vishika mam, she was super flexible and always replied to me whenever I messaged her. I just wanted to let you know, if you actually want to score your desired band, then LA Academy is your ultimate destination.",
        image: "/images/web-new-images/new-content-slider/shreya-pokhrel.svg",
      },
      {
        id: 9,
        name: "Satyam Kannaujia",
        location: "Lucknow, Uttar Pradesh, India",
        description:
          "I highly recommend LA to people who are looking for guidance to excel in their PTE exam. The tutors are very helpful and their guidance really works. I would like to thank all of the LA team for helping me to achieve my desired score",
        image: "/images/web-new-images/new-content-slider/satyam-kannaujia.svg",
      },
    ]
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>PTE Core Online Training | PTE for Canada | LA Language Academy</title>
        <meta name="description" content="Prepare for PTE Core with LA Language Academy. Learn about PTE for Canada and how it help you crack PTE Core for Canada PR (Permanent Residency)." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/pte-core`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="PTE Core Online Training | PTE for Canada | LA Language Academy" />
        <meta name="twitter:description" content="Prepare for PTE Core with LA Language Academy. Learn about PTE for Canada and how it help you crack PTE Core for Canada PR (Permanent Residency)." />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/pte-core`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PTE Core Online Training | PTE for Canada | LA Language Academy" />
        <meta property="og:description" content="Prepare for PTE Core with LA Language Academy. Learn about PTE for Canada and how it help you crack PTE Core for Canada PR (Permanent Residency)." />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
        <Header />
        {/* <BannerHeader title={bannerTitle} blueBoxText={blueBoxText} subTitle={subTitleSection} backgroundColor='#182A4F' textColor="white" middleSection={() => {
          return (  <div className="banner-img-wrapper" style={{paddingBottom: '232px'}}>
              <img
            className="banner-img"
            src={bannerImage}
            alt="LA"  
          />
          </div>)
        }} /> */}

         <HeroSectionUpdated data={heroData} />
        <div className="fame-wall off-white">
          <ReusableHomePageSlider images={images} />
        </div>
        <div className="d-flex align-items-center gap-3 flex-column pb-4 off-white">
          {heroDescriptionSection()}
          <ButtonComp link={"/auth/register"} btnText={"Register For Preparation Now"} />
        </div>
        <div className="custom-container py-5">
          {/* <div className="align-items-center justify-content-between row">
            
            <div className="col-lg-5 mb-4 mb-lg-0">
              <h1 className="hero-title">
               <span className="text-success FS40FW600">What Is PTE Core? </span><br/>
               The Official Canadian Immigration Test
              </h1>

              <div className="quote-box mt-3 FS18FW400">
               PTE Core preparation is the fastest path to proving your <b>English</b> proficiency for Canadian immigration with results in just <b>24 hours</b>.
              </div>

              <p className="mt-3 FS16FW500">
                The pte core exam pattern is a fully digital English language proficiency exam officially approved by Immigration, Refugees, and Citizenship Canada (IRCC). 
              </p>
               <p className="mt-3 FS16FW500">
                Accepted for all immigration programs including:
              </p>
              <div className="d-flex gap-3">
                  <ul className="academy-feature-list">
                <li className="FS16FW500 fw-normal">Federal Skilled Worker Program</li>
                <li className="FS16FW500 fw-normal">Provincial Nominee Programs
                </li>
                </ul>
                <ul className="academy-feature-list">
                <li className="FS16FW500 fw-normal">Canadian Experience Class</li>
                <li className="FS16FW500 fw-normal">Study permits and work visas</li>
                </ul>
              </div>
              <ButtonComp link={"/contact"} btnText={"Register For Free"} className={"mt-2"}/>
            </div>
             <div className="col-lg-6">
                <img className="immigration-test-img"
                  src={Immigration}
                  alt="Immigration-test"
                />
            </div>
          </div> */}
          <ContentImageSection
            contentSection={contentSection}
            quoteText='PTE Core preparation is the fastest path to proving your <span class="fw-700">English</span> proficiency for Canadian immigration with results in just <span class="fw-700">24 hours</span>.'
            paragraphs={[
              "The pte core exam pattern is a fully digital English language proficiency exam officially approved by Immigration, Refugees, and Citizenship Canada (IRCC).",
            ]}
            listSectionTitle="Accepted for all immigration programs including:"
            listColumns={[
              ["Federal Skilled Worker Program", "Provincial Nominee Programs"],
              ["Canadian Experience Class", "Study permits and work visas"],
            ]}
            btnLink="/auth/register"
            btnText="Start Free PTE Practice"
            btnClassName="mt-2"
            image={Immigration}
            imageClassName="immigration-test-img"
          />
        </div>
        <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          btnText={"Prepare For PTE Core Today"}
          skillSubtitle={"Using advanced AI-driven scoring, PTE Core delivers unbiased assessment with results in just 48 hours, making it the fastest option for immigration applicants."}
        />
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle2}
          lifestyleCards={styleCards}
          btnText={"Start Your Preparation Now"}
          skillSubtitle={"Our PTE Core Practice Website offers comprehensive PTE Core resources to help you understand these key advantages"}
        />
        <ComparisonSection
          data={comparisionData}
          comparisionTopText={comparisionTopText}
          comparisionDescriptionText={`Say goodbye to the delays and complications of traditional language tests. Choose PTE Core for a <br/> streamlined and efficient testing experience.`} />

        <TestSection data={testData} bgColor="#080F1E" />

        <ImmigrationSection data={immigrationData} />

        <AdvantageSection data={advantageSectionData} />

        <TestimonialSection
          title={`<span class="hero-title FS40FW600 text-center mb-0">Students' <span class="green-text">Success Stories</span></span>`}
          showBtn={false}
          sliderList={sliderList}
        />

        <AiPower btnText="Start Free PTE Practice" />

        {/* <PricingSection data={pricingSectionData} /> */}
        <div className="container py-5">
                  <div className="text-center">
                    <h3 className='main-title FS40FW600 mb-0'>Start Your  <span className='text-success FS40FW600'>PTE Core</span> Preparation <br/>Journey Today</h3>
                    <p className="quote-para FS18FW400 fw-500 py-4">Choose your preparation package, starting from $29</p>
                  </div>
                  <div className="row justify-content-center">
        
                    <PricingCard
                      title="PACKAGE 1"
                      subtitle="Online Platform"
                      price="29"
                      features={[
                        "AI-Powered Portal Access",
                        "Complete Question Bank",
                        "Scored Mock Tests",
                        "Updated Templates",
                        "Self-Paced Video Lessons",
                      ]}
                      description={'All core features, enhanced with'}
                    />
        
                    <PricingCard
                      title="PACKAGE 2"
                      subtitle="Online Coaching"
                      price="199"
                      isPopular={true}
                      dark={true}
                      features={[
                        "Live Virtual Classes",
                        "Personalized Feedback",
                        "Direct Trainer Access",
                        "Updated Prediction Files",
                        "Priority Support",
                      ]}
                      description={'Everything in Online Platform, plus'}
                    />
        
                    <PricingCard
                      title="PACKAGE 3"
                      subtitle="Campus Coaching"
                      price="199"
                      features={[
                        "In-Person Training",
                        "One-on-one Sessions",
                        "Intensive Workshops",
                        "Extend Support",
                        "Exam Booking Assistance",
                      ]}
                      description={'Everything in Platform Online Platform, plus'}
                    />
        
                  </div>
                </div>
        

        {/* <PteAppBanner /> */}
        <AppBannerCustom
          appName="PTE"
          description="PTE PRACTICE"
          mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
          playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
          appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
        />

        <FaqSection questions={faqQuestions} />
        {/* <CrackedCodeSlider title={`<span className="fw-700">WHAT OUR</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">STUDENTS SAY</span>`} /> */}
        {/* <div className="noc-ccl-exam naati-ccl-exam what-ielts pccp-pte">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <h2 className="primary-heading text-center fw-700">
                <span className="wpl-badge text-white">WHAT IS PTE CORE?</span>
                <br className="d-block" />
                THE OFFICIAL CANADIAN <br /> IMMIGRATION TEST
              </h2>
            </div>
            <div className="col-md-6">
              <div className="ccl-exam-img">
                <img
                  className="img-fluid"
                  src="/images/web-new-images/pccp-img.jpg"
                  alt="Register Now"
                />
              </div>
            </div>
            <div className="col-md-6 what-ielts-content">
              <p>
                PTE Core preparation is the fastest path to proving your
                English proficiency for Canadian immigration with results in
                just 24 hours.
                <br />
                <br />
                The pte core exam pattern is a fully digital English language
                proficiency exam officially approved by Immigration, <br />
                Refugees, and Citizenship Canada (IRCC).
              </p>
              <h4 className="mt-4 mb-3 fw-700" style={{ fontSize: '20px', color: '#0d1830' }}>Accepted for all immigration programs including:</h4>
              <ul className="list-unstyled">
                <li className="d-flex align-items-center mb-2" style={{ fontSize: '16px', color: '#4b5563' }}>
                  <span className="me-2 flex-shrink-0" style={{ width: '16px', height: '16px', border: '1.5px solid #7F56D9', borderRadius: '50%', display: 'inline-block' }}></span>
                  Federal Skilled Worker Program
                </li>
                <li className="d-flex align-items-center mb-2" style={{ fontSize: '16px', color: '#4b5563' }}>
                  <span className="me-2 flex-shrink-0" style={{ width: '16px', height: '16px', border: '1.5px solid #7F56D9', borderRadius: '50%', display: 'inline-block' }}></span>
                  Canadian Experience Class
                </li>
                <li className="d-flex align-items-center mb-2" style={{ fontSize: '16px', color: '#4b5563' }}>
                  <span className="me-2 flex-shrink-0" style={{ width: '16px', height: '16px', border: '1.5px solid #7F56D9', borderRadius: '50%', display: 'inline-block' }}></span>
                  Provincial Nominee Programs
                </li>
                <li className="d-flex align-items-center mb-2" style={{ fontSize: '16px', color: '#4b5563' }}>
                  <span className="me-2 flex-shrink-0" style={{ width: '16px', height: '16px', border: '1.5px solid #7F56D9', borderRadius: '50%', display: 'inline-block' }}></span>
                  Study permits and work visas
                </li>
              </ul>
            </div>
          </div>

          <SkillAssment skillAreaTitle={skillAreaTitle} skillData={skillData} />
        </div>
      </div> */}
        {/* <div className="pc-pte-core">
        <div className="container">
          <div className="row">
            <h2 className="primary-heading text-center">
              <span className="free-mock-text">WHAT IS PTE CORE?</span>
              <br /> THE OFFICIAL CANADIAN <br /> IMMIGRATION TEST
            </h2>
            <div className="pc-pte-core-content">
              <div>
                <div className="light-blue-box">PTE Core preparation is the fastest path to proving your English proficiency for Canadian immigration with results in just 24 hours.</div>
                <p className="sub-heading">The pte core exam pattern is a fully digital English language proficiency exam officially approved by Immigration, Refugees, and Citizenship Canada (IRCC).</p>
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    PREPARE FOR PTE CORE TODAY <img src="/images/web-new-images/right-arrow-black.svg" alt="Register Now" />
                  </span>
                </Link>
              </div>
              <div className="pc-pte-core-list">
                <h2 className="pc-pte-core-title">Accepted for all immigration programs including:</h2>
                <ul>
                  <li>Federal Skilled Worker Program</li>
                  <li>Canadian Experience Class</li>
                  <li>Provincial Nominee Programs</li>
                  <li>Study permits and work visas</li>
                </ul>
              </div>
            </div>
            <div className="pc-skill-areas">
              <h2 className="pc-pte-core-title">The 3-hour computer-based test evaluates four essential skill areas:</h2>
              <div className="skill-areas-content">
                <div className="left-area">
                  <h2>Skill Area</h2>
                  <ul>
                    <li>Reading</li>
                    <li>Writing</li>
                    <li>Listening</li>
                    <li>Speaking</li>
                  </ul>
                </div>
                <div className="right-area">
                  <h2>What It Tests</h2>
                  <ul>
                    <li>Comprehension, analysis, vocabulary</li>
                    <li>Essay writing, summarizing information</li>
                    <li>Understanding spoken English, note-taking</li>
                    <li>Pronunciation, fluency, clarity</li>
                  </ul>
                </div>
              </div>
              <div className="light-blue-box">Using advanced <span>AI-driven scoring,</span> PTE Core delivers unbiased assessment with <span>results in just 24 hours,</span> making it the fastest option for immigration applicants.</div>
            </div>
          </div>
        </div>
      </div> */}
        {/* <WhyChoose whyChooseSectionHeader={whyChooseSectionHeader} />



      <div class="ptecore-othertest">

        <h2 class="primary-heading">
          PTE Core vs. Other Tests<br />
          <span class="wpl-badge pte-naati-badge text-white">
            Side-by-Side Comparison
          </span>
        </h2>


        <div class="ptecore-othertest-list d-none d-md-grid">

          <ul>
            <li class="title">Feature</li>
            <li>Results Timeframe</li>
            <li>Scoring Method</li>
            <li>Test Availability</li>
            <li>Global Recognition</li>
            <li>Digital Format</li>
          </ul>

          <ul>
            <li class="title">PTE Core</li>
            <li>24 hours</li>
            <li>AI-driven (objective)</li>
            <li>Year-round, flexible</li>
            <li>118+ Countries</li>
            <li>Fully Digital</li>
          </ul>

          <ul>
            <li class="title">IELTS</li>
            <li>13-15 days</li>
            <li>Human examiners</li>
            <li>Limited dates</li>
            <li>140+ countries</li>
            <li>Paper &amp; digital options</li>
          </ul>

          <ul>
            <li class="title">CELPIP</li>
            <li>5-8 days</li>
            <li>Mixed evaluation</li>
            <li>Select centres only</li>
            <li>Canada-focused</li>
            <li>Computer-based only</li>
          </ul>

        </div>


        <div class="ptecore-othertest-slider slider-dot-arrow d-block d-md-none">

          <div class="slick-slider slick-initialized" dir="ltr">

            <button type="button" class="slick-arrow slick-prev">
              Previous
            </button>

            <div class="slick-list">
              <div class="slick-track">


                <div class="slick-slide slick-active slick-current">
                  <div class="pc-mobile-card">
                    <div class="pc-mobile-card-header">
                      <h2 class="title">Feature</h2>
                      <h2 class="sub-title">PTE Core</h2>
                    </div>
                    <div class="pc-mobile-card-content">
                      <ul>
                        <li><span class="left-col">Results Timeframe</span><span class="right-col">24 hours</span></li>
                        <li><span class="left-col">Scoring Method</span><span class="right-col">AI-driven (objective)</span></li>
                        <li><span class="left-col">Test Availability</span><span class="right-col">Year-round, flexible</span></li>
                        <li><span class="left-col">Global Recognition</span><span class="right-col">118+ Countries</span></li>
                        <li><span class="left-col">Digital Format</span><span class="right-col">Fully Digital</span></li>
                      </ul>
                    </div>
                  </div>
                </div>


                <div class="slick-slide">
                  <div class="pc-mobile-card">
                    <div class="pc-mobile-card-header">
                      <h2 class="title">Feature</h2>
                      <h2 class="sub-title">IELTS</h2>
                    </div>
                    <div class="pc-mobile-card-content">
                      <ul>
                        <li><span class="left-col">Results Timeframe</span><span class="right-col">13-15 days</span></li>
                        <li><span class="left-col">Scoring Method</span><span class="right-col">Human examiners</span></li>
                        <li><span class="left-col">Test Availability</span><span class="right-col">Limited dates</span></li>
                        <li><span class="left-col">Global Recognition</span><span class="right-col">140+ countries</span></li>
                        <li><span class="left-col">Digital Format</span><span class="right-col">Paper &amp; digital options</span></li>
                      </ul>
                    </div>
                  </div>
                </div>


                <div class="slick-slide">
                  <div class="pc-mobile-card">
                    <div class="pc-mobile-card-header">
                      <h2 class="title">Feature</h2>
                      <h2 class="sub-title">CELPIP</h2>
                    </div>
                    <div class="pc-mobile-card-content">
                      <ul>
                        <li><span class="left-col">Results Timeframe</span><span class="right-col">5-8 days</span></li>
                        <li><span class="left-col">Scoring Method</span><span class="right-col">Mixed evaluation</span></li>
                        <li><span class="left-col">Test Availability</span><span class="right-col">Select centres only</span></li>
                        <li><span class="left-col">Global Recognition</span><span class="right-col">Canada-focused</span></li>
                        <li><span class="left-col">Digital Format</span><span class="right-col">Computer-based only</span></li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <button type="button" class="slick-arrow slick-next">
              Next
            </button>

            <ul class="slick-dots">
              <li class="slick-active"><button>1</button></li>
              <li><button>2</button></li>
              <li><button>3</button></li>
            </ul>

          </div>
        </div>

        <div class="light-blue-box">
          Say goodbye to the delays and complications of traditional language tests.
          Choose PTE Core for a streamlined and efficient testing experience.
        </div>

      </div>


      <div className="pc-pte-core-sec">
        <div className="container">
          <div className="row pte-two-col text-white">
            <div className="col-lg-6">
              <h2 className="primary-heading text-white">
                <span className="wpl-badge text-white">PTE CORE</span>
                <br />
                ESSENTIAL FOR CANADIAN<br />IMMIGRATION SUCCESS
              </h2>
              <div className="light-blue-box">Meeting language requirements is the #1 factor for successful Express Entry applications</div>
              <br />
              <Link className="primary-btn" to="/auth/register">
                <span className="btn-inner">
                  BEGIN YOUR TEST PREPARATION <img src="/images/web-new-images/right-arrow-black.svg" alt="Register Now" />
                </span>
              </Link>
            </div>
            <div className="col-lg-6">
              <h3>Scoring well in PTE Core is a crucial step for Canadian immigration. The test directly impacts your</h3>
              <ul>
                <li><span className="circle"></span> Comprehensive Ranking System (CRS) points for Express Entry</li>
                <li><span className="circle"></span> Provincial Nominee Program eligibility</li>
                <li><span className="circle"></span> Study and work permit applications</li>
              </ul>
            </div>
          </div>
          <div className="pc-pte-card-content">
            <h2 className="title">Requirements by immigration program</h2>
            <div className="pc-pte-cards d-none d-md-grid">
              <div className="pc-pte-card">
                <h2>Program</h2>
                <ul>
                  <li>Express Entry (FSW)</li>
                  <li>Canadian Experience</li>
                  <li>Provincial Nominee</li>
                  <li>Study Permits</li>
                </ul>
              </div>
              <div className="pc-pte-card">
                <h2>Minimum CLB</h2>
                <ul>
                  <li>CLB 7</li>
                  <li>CLB 7-9</li>
                  <li>Varies</li>
                  <li>Program-based</li>
                </ul>
              </div>
              <div className="pc-pte-card">
                <h2>Recommended PTE Score</h2>
                <ul>
                  <li>60+ in all skills</li>
                  <li>60-75+ in all skills</li>
                  <li>Program-specific</li>
                  <li>Usually 50+</li>
                </ul>
              </div>
            </div>
            <div className="d-flex d-md-none pc-pte-mobile-card">
              <div className="pc-mobile-card">
                <div className="pc-mobile-card-header">
                  <h2 className="title">Program</h2>
                  <h2 className="sub-title">Minimum CLB</h2>
                </div>
                <div className="pc-mobile-card-content">
                  <ul>
                    <li>
                      <span className="left-col">Express Entry (FSW)</span>
                      <span className="right-col">CLB 7</span>
                    </li>
                    <li>
                      <span className="left-col">Canadian Experience</span>
                      <span className="right-col">CLB 7-9</span>
                    </li>
                    <li>
                      <span className="left-col">Provincial Nominee</span>
                      <span className="right-col">Varies</span>
                    </li>
                    <li>
                      <span className="left-col">Study Permits</span>
                      <span className="right-col">Program-based</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="pc-mobile-card">
                <div className="pc-mobile-card-header">
                  <h2 className="title">Program</h2>
                  <h2 className="sub-title">Recommended PTE Score</h2>
                </div>
                <div className="pc-mobile-card-content">
                  <ul>
                    <li>
                      <span className="left-col">Express Entry (FSW)</span>
                      <span className="right-col">60+ in all skills</span>
                    </li>
                    <li>
                      <span className="left-col">Canadian Experience</span>
                      <span className="right-col">60-75+ in all skills</span>
                    </li>
                    <li>
                      <span className="left-col">Provincial Nominee</span>
                      <span className="right-col">Program-specific</span>
                    </li>
                    <li>
                      <span className="left-col">Study Permits</span>
                      <span className="right-col">Usually 50+</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="light-blue-box">
              The PTE Core test ensures you have the necessary communication skills to integrate successfully into Canadian society and workplace environments.
            </div>
          </div>
        </div>
      </div>


      <div className="conversion-table">
        <div className="container">
          <div className="row">
            <div className="conversion-header">
              <h2 className="primary-heading fw-700 text-center text-white">
                <span className="wpl-badge pte-naati-badge text-white">PTE Core to cbl</span>
                <br />
                conversion table
              </h2>
            </div>
            <div className="conversion-table-content d-none d-md-grid">
              <div className="left-side-content">
                <h2 className="table-title">CLB Level</h2>
                <ul>
                  <li>10</li>
                  <li>9</li>
                  <li>8</li>
                  <li>7</li>
                  <li>6</li>
                  <li>5</li>
                  <li>4</li>
                  <li>3</li>
                </ul>
              </div>
              <div className="right-side-content">
                <h2 className="table-title">PTE Core</h2>
                <div className="right-side-table">
                  <ul className="first-col">
                    <li className="list-table-title">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      Speaking</li>
                    <li>89 - 90</li>
                    <li>84 - 88</li>
                    <li>76 - 83</li>
                    <li>68 - 75</li>
                    <li>59 - 67</li>
                    <li>51 - 58</li>
                    <li>42 - 50</li>
                    <li>34 - 41</li>
                  </ul>
                  <ul className="second-col">
                    <li className="list-table-title">
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.25 6.077L6.75182 7.37663C6.38882 7.44923 6.20733 7.48553 6.05952 7.5738C5.92886 7.65184 5.81772 7.75867 5.7346 7.88616C5.64057 8.03036 5.59714 8.21029 5.51028 8.57014L2.25 22.077M2.25 22.077L15.7569 18.8167C16.1167 18.7299 16.2966 18.6864 16.4408 18.5924C16.5683 18.5093 16.6752 18.3981 16.7532 18.2675C16.8415 18.1197 16.8778 17.9382 16.9504 17.5752L18.25 11.077M2.25 22.077L9.836 14.491M21.1186 7.94563L16.3814 3.20837C15.9854 2.81235 15.7873 2.61434 15.559 2.54015C15.3582 2.4749 15.1418 2.4749 14.941 2.54015C14.7127 2.61434 14.5146 2.81235 14.1186 3.20837L13.3814 3.94563C12.9854 4.34164 12.7873 4.53965 12.7132 4.76798C12.6479 4.96882 12.6479 5.18517 12.7132 5.38601C12.7873 5.61434 12.9854 5.81235 13.3814 6.20837L18.1186 10.9456C18.5146 11.3416 18.7127 11.5397 18.941 11.6138C19.1418 11.6791 19.3582 11.6791 19.559 11.6138C19.7873 11.5397 19.9854 11.3416 20.3814 10.9456L21.1186 10.2084C21.5146 9.81235 21.7127 9.61434 21.7868 9.38601C21.8521 9.18517 21.8521 8.96882 21.7868 8.76798C21.7127 8.53965 21.5146 8.34164 21.1186 7.94563ZM11.25 11.077C12.3546 11.077 13.25 11.9724 13.25 13.077C13.25 14.1816 12.3546 15.077 11.25 15.077C10.1454 15.077 9.25 14.1816 9.25 13.077C9.25 11.9724 10.1454 11.077 11.25 11.077Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      Writing</li>
                    <li>90</li>
                    <li>88 - 89</li>
                    <li>79 - 87</li>
                    <li>69 - 78</li>
                    <li>60 - 68</li>
                    <li>51 - 59</li>
                    <li>41 - 50</li>
                    <li>32 - 40</li>
                  </ul>
                  <ul className="third-col">
                    <li className="list-table-title">
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 21.0771L12.3999 20.9271C11.7053 19.8851 11.358 19.3641 10.8991 18.987C10.4929 18.6531 10.0248 18.4026 9.52161 18.2498C8.95325 18.0771 8.32711 18.0771 7.07482 18.0771H5.7C4.5799 18.0771 4.01984 18.0771 3.59202 17.8592C3.21569 17.6674 2.90973 17.3615 2.71799 16.9851C2.5 16.5573 2.5 15.9973 2.5 14.8771V6.27715C2.5 5.15704 2.5 4.59699 2.71799 4.16917C2.90973 3.79284 3.21569 3.48688 3.59202 3.29514C4.01984 3.07715 4.5799 3.07715 5.7 3.07715H6.1C8.34021 3.07715 9.46032 3.07715 10.316 3.51312C11.0686 3.89662 11.6805 4.50854 12.064 5.26119C12.5 6.11683 12.5 7.23694 12.5 9.47715M12.5 21.0771V9.47715M12.5 21.0771L12.6001 20.9271C13.2947 19.8851 13.642 19.3641 14.1009 18.987C14.5071 18.6531 14.9752 18.4026 15.4784 18.2498C16.0468 18.0771 16.6729 18.0771 17.9252 18.0771H19.3C20.4201 18.0771 20.9802 18.0771 21.408 17.8592C21.7843 17.6674 22.0903 17.3615 22.282 16.9851C22.5 16.5573 22.5 15.9973 22.5 14.8771V6.27715C22.5 5.15704 22.5 4.59699 22.282 4.16917C22.0903 3.79284 21.7843 3.48688 21.408 3.29514C20.9802 3.07715 20.4201 3.07715 19.3 3.07715H18.9C16.6598 3.07715 15.5397 3.07715 14.684 3.51312C13.9314 3.89662 13.3195 4.50854 12.936 5.26119C12.5 6.11683 12.5 7.23694 12.5 9.47715" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      Reading</li>
                    <li>88 - 90</li>
                    <li>78 - 87</li>
                    <li>69 - 77</li>
                    <li>60 - 68</li>
                    <li>51 - 59</li>
                    <li>42 - 50</li>
                    <li>33 - 41</li>
                    <li>24 - 32</li>
                  </ul>
                  <ul className="forth-col">
                    <li className="list-table-title">
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.75 18.0771V12.0771C21.75 7.10659 17.7206 3.07715 12.75 3.07715C7.77944 3.07715 3.75 7.10659 3.75 12.0771V18.0771M6.25 21.0771C4.86929 21.0771 3.75 19.9579 3.75 18.5771V16.5771C3.75 15.1964 4.86929 14.0771 6.25 14.0771C7.63071 14.0771 8.75 15.1964 8.75 16.5771V18.5771C8.75 19.9579 7.63071 21.0771 6.25 21.0771ZM19.25 21.0771C17.8693 21.0771 16.75 19.9579 16.75 18.5771V16.5771C16.75 15.1964 17.8693 14.0771 19.25 14.0771C20.6307 14.0771 21.75 15.1964 21.75 16.5771V18.5771C21.75 19.9579 20.6307 21.0771 19.25 21.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      Listening</li>
                    <li>89 - 90</li>
                    <li>82 - 88</li>
                    <li>71 - 81</li>
                    <li>60 - 70</li>
                    <li>50 - 59</li>
                    <li>39 - 49</li>
                    <li>28 - 38</li>
                    <li>18 - 27</li>
                  </ul>
                </div>
              </div>
            </div>
  
            <div className="slider-dot-arrow pc-pte-mobile-card d-block d-md-none">
              <Slider {...CardSlider}>
                <div className="pc-mobile-card speaking">
                  <div className="pc-mobile-card-header">
                    <h2 className="title">PTE Core</h2>
                    <h2 className="sub-title">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg> Speaking</h2>
                  </div>
                  <div className="pc-mobile-card-content">
                    <ul>
                      <li>
                        <span className="left-col">CLB Level</span>
                        <span className="right-col"></span>
                      </li>
                      <li>
                        <span className="left-col">10</span>
                        <span className="right-col">89 - 90</span>
                      </li>
                      <li>
                        <span className="left-col">9</span>
                        <span className="right-col">84 - 88</span>
                      </li>
                      <li>
                        <span className="left-col">8</span>
                        <span className="right-col">76 - 83</span>
                      </li>
                      <li>
                        <span className="left-col">7</span>
                        <span className="right-col">68 - 75</span>
                      </li>
                      <li>
                        <span className="left-col">6</span>
                        <span className="right-col">59 - 67</span>
                      </li>
                      <li>
                        <span className="left-col">5</span>
                        <span className="right-col">51 - 58</span>
                      </li>
                      <li>
                        <span className="left-col">4</span>
                        <span className="right-col">42 - 50</span>
                      </li>
                      <li>
                        <span className="left-col">3</span>
                        <span className="right-col">34 - 41</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="pc-mobile-card writing">
                  <div className="pc-mobile-card-header">
                    <h2 className="title">PTE Core</h2>
                    <h2 className="sub-title">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg> Writing</h2>
                  </div>
                  <div className="pc-mobile-card-content">
                    <ul>
                      <li>
                        <span className="left-col">CLB Level</span>
                        <span className="right-col"></span>
                      </li>
                      <li>
                        <span className="left-col">10</span>
                        <span className="right-col">90</span>
                      </li>
                      <li>
                        <span className="left-col">9</span>
                        <span className="right-col">88 - 89</span>
                      </li>
                      <li>
                        <span className="left-col">8</span>
                        <span className="right-col">79 - 87</span>
                      </li>
                      <li>
                        <span className="left-col">7</span>
                        <span className="right-col">69 - 78</span>
                      </li>
                      <li>
                        <span className="left-col">6</span>
                        <span className="right-col">60 - 68</span>
                      </li>
                      <li>
                        <span className="left-col">5</span>
                        <span className="right-col">51 - 59</span>
                      </li>
                      <li>
                        <span className="left-col">4</span>
                        <span className="right-col">41 - 50</span>
                      </li>
                      <li>
                        <span className="left-col">3</span>
                        <span className="right-col">32 - 40</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="pc-mobile-card reading">
                  <div className="pc-mobile-card-header">
                    <h2 className="title">PTE Core</h2>
                    <h2 className="sub-title">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg> Reading</h2>
                  </div>
                  <div className="pc-mobile-card-content">
                    <ul>
                      <li>
                        <span className="left-col">CLB Level</span>
                        <span className="right-col"></span>
                      </li>
                      <li>
                        <span className="left-col">10</span>
                        <span className="right-col">88 - 90</span>
                      </li>
                      <li>
                        <span className="left-col">9</span>
                        <span className="right-col">78 - 87</span>
                      </li>
                      <li>
                        <span className="left-col">8</span>
                        <span className="right-col">69 - 77</span>
                      </li>
                      <li>
                        <span className="left-col">7</span>
                        <span className="right-col">60 - 68</span>
                      </li>
                      <li>
                        <span className="left-col">6</span>
                        <span className="right-col">51 - 59</span>
                      </li>
                      <li>
                        <span className="left-col">5</span>
                        <span className="right-col">42 - 50</span>
                      </li>
                      <li>
                        <span className="left-col">4</span>
                        <span className="right-col">33 - 41</span>
                      </li>
                      <li>
                        <span className="left-col">3</span>
                        <span className="right-col">24 - 32</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="pc-mobile-card listening">
                  <div className="pc-mobile-card-header">
                    <h2 className="title">PTE Core</h2>
                    <h2 className="sub-title">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg> Listening</h2>
                  </div>
                  <div className="pc-mobile-card-content">
                    <ul>
                      <li>
                        <span className="left-col">CLB Level</span>
                        <span className="right-col"></span>
                      </li>
                      <li>
                        <span className="left-col">10</span>
                        <span className="right-col">89 - 90</span>
                      </li>
                      <li>
                        <span className="left-col">9</span>
                        <span className="right-col">82 - 88</span>
                      </li>
                      <li>
                        <span className="left-col">8</span>
                        <span className="right-col">71 - 81</span>
                      </li>
                      <li>
                        <span className="left-col">7</span>
                        <span className="right-col">60 - 70</span>
                      </li>
                      <li>
                        <span className="left-col">6</span>
                        <span className="right-col">50 - 59</span>
                      </li>
                      <li>
                        <span className="left-col">5</span>
                        <span className="right-col">39 - 49</span>
                      </li>
                      <li>
                        <span className="left-col">4</span>
                        <span className="right-col">28 - 38</span>
                      </li>
                      <li>
                        <span className="left-col">3</span>
                        <span className="right-col">18 - 27</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div> */}

        {/* <div className="master-all-pte d-none">
        <div className="container">
          <div className="row">
            <div className="master-all-header">
              <h2 className="primary-heading fw-700 text-center text-white">
                EXCEL IN EVERY
                <br />
                <span className="wpl-badge pte-naati-badge text-white">PTE SKILL AREA</span> WITH
                <br />
                OUR STRATEGIES
              </h2>
              <p className="sub-heading text-center text-white">Our specialized PTE Core Course helps you excel in every <br className="d-none d-md-block" /> component of the PTE Core exam:</p>
            </div>
          </div>
          <div className="master-all-tabs">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="speak-tab" data-bs-toggle="tab" data-bs-target="#speak-tab-pane" type="button" role="tab" aria-controls="speak-tab-pane" aria-selected="true"><img src="/images/web-new-images/icons/w-speak-icon.svg" alt="Register Now" /> Speaking
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="write-tab" data-bs-toggle="tab" data-bs-target="#write-tab-pane" type="button" role="tab" aria-controls="write-tab-pane" aria-selected="false"><img src="/images/web-new-images/icons/w-write-icon.svg" alt="Register Now" /> Writing
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false"><img src="/images/web-new-images/icons/w-reading-icon.svg" alt="Register Now" /> Reading
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="false"><img src="/images/web-new-images/icons/w-listen-icon.svg" alt="Register Now" /> Listening
                </button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade"
                id="home-tab-pane"
                role="tabpanel"
                aria-labelledby="home-tab"
                tabIndex="0"
              >
                <div className="lets-coaching-tab-cards">
                  <div className="lets-coaching-tab-left-card">
                    <div className="card-img">
                      <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="54" height="52" rx="16" fill="#0286FF" />
                        <g clip-path="url(#clip0_17515_8851)">
                          <path d="M39.7308 13.5798C36.3328 10.1819 31.8116 8.31055 27 8.31055C22.1884 8.31055 17.6672 10.1819 14.2692 13.5798C10.8713 16.9776 9 21.4989 9 26.3105C9 31.1222 10.8713 35.6434 14.2692 39.0413C17.6671 42.4393 22.1884 44.3105 27 44.3105C31.8116 44.3105 36.3328 42.4392 39.7308 39.0413C43.1287 35.6435 45 31.1222 45 26.3105C45 21.4989 43.1287 16.9777 39.7308 13.5798ZM27 42.0837C18.3026 42.0837 11.2268 35.0079 11.2268 26.3105C11.2268 17.6132 18.3026 10.5374 27 10.5374C35.6974 10.5374 42.7732 17.6132 42.7732 26.3105C42.7732 35.0079 35.6974 42.0837 27 42.0837Z" fill="white" />
                          <path d="M35.7497 17.561C33.4143 15.2257 30.3069 13.9395 27.0001 13.9395C23.6932 13.9395 20.5858 15.2256 18.2504 17.561C15.915 19.8964 14.6289 23.0037 14.6289 26.3106C14.6289 29.6175 15.915 32.7248 18.2504 35.0602C20.5858 37.3956 23.6932 38.6818 27.0001 38.6818C30.3069 38.6818 33.4143 37.3956 35.7497 35.0602C38.0851 32.7248 39.3712 29.6175 39.3712 26.3106C39.3712 23.0037 38.0851 19.8964 35.7497 17.561ZM27.0001 36.455C21.4065 36.455 16.8557 31.9042 16.8557 26.3106C16.8557 20.717 21.4065 16.1663 27.0001 16.1663C32.5936 16.1663 37.1444 20.717 37.1444 26.3106C37.1444 31.9042 32.5936 36.455 27.0001 36.455Z" fill="white" />
                          <path d="M27.0001 19.5684C23.2823 19.5684 20.2578 22.593 20.2578 26.3106C20.2578 30.0283 23.2823 33.0528 27.0001 33.0528C30.7178 33.0528 33.7423 30.0283 33.7423 26.3106C33.7423 22.593 30.7178 19.5684 27.0001 19.5684ZM27.0001 30.826C24.5103 30.826 22.4846 28.8004 22.4846 26.3106C22.4846 23.8208 24.5103 21.7952 27.0001 21.7952C29.4898 21.7952 31.5155 23.8208 31.5155 26.3106C31.5155 28.8004 29.4898 30.826 27.0001 30.826Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17515_8851">
                            <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                          </clipPath>
                        </defs>
                      </svg>


                    </div>
                    <h2 className="m-0">What It Tests</h2>
                    <ul className="p-0">
                      <li>
                        Ability to comprehend spoken English, understand main ideas, and follow instructions.
                      </li>
                    </ul>
                  </div>
                  <div className="lets-coaching-tab-right-card">
                    <div className="card-img">
                      <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="54" height="52" rx="16" fill="#0286FF" />
                        <g clip-path="url(#clip0_17515_8861)">
                          <path d="M24.7284 17.0819C21.3516 17.8692 18.6332 20.5472 17.8031 23.9044C16.9704 27.2723 17.9234 30.7051 20.3526 33.0873C21.2118 33.93 21.7248 35.2806 21.7248 36.7003V36.9269C21.7248 37.8618 22.1327 38.703 22.7795 39.2827V41.1456C22.7795 42.8903 24.1989 44.3097 25.9436 44.3097H28.053C29.7976 44.3097 31.217 42.8903 31.217 41.1456V39.2827C31.8638 38.703 32.2717 37.8618 32.2717 36.9269V36.6961C32.2717 35.298 32.8122 33.9217 33.7176 33.0145C35.5057 31.2224 36.4905 28.8413 36.4905 26.3097C36.4905 20.2573 30.8817 15.6476 24.7284 17.0819ZM29.1077 41.1456C29.1077 41.7272 28.6345 42.2003 28.053 42.2003H25.9436C25.362 42.2003 24.8889 41.7272 24.8889 41.1456V40.0909H29.1077V41.1456ZM32.2243 31.5245C30.9139 32.8377 30.1623 34.7227 30.1623 36.6961V36.9269C30.1623 37.5084 29.6892 37.9816 29.1077 37.9816H24.8889C24.3073 37.9816 23.8342 37.5084 23.8342 36.9269V36.7003C23.8342 34.6964 23.1035 32.8306 21.8294 31.5812C19.9387 29.7271 19.1991 27.0466 19.8507 24.4107C20.4923 21.8157 22.595 19.7452 25.2074 19.1362C30.0359 18.0103 34.3811 21.6148 34.3811 26.3097C34.3811 28.2787 33.6151 30.1307 32.2243 31.5245Z" fill="white" />
                          <path d="M18.7953 16.6162L15.8122 13.6331C15.4004 13.2212 14.7325 13.2212 14.3206 13.6331C13.9087 14.045 13.9087 14.7128 14.3206 15.1247L17.3038 18.1078C17.7156 18.5196 18.3835 18.5196 18.7953 18.1078C19.2072 17.6959 19.2072 17.0281 18.7953 16.6162Z" fill="white" />
                          <path d="M14.3438 25.2559H10.0547C9.47222 25.2559 9 25.7281 9 26.3105C9 26.893 9.47222 27.3652 10.0547 27.3652H14.3438C14.9262 27.3652 15.3984 26.893 15.3984 26.3105C15.3984 25.7281 14.9262 25.2559 14.3438 25.2559Z" fill="white" />
                          <path d="M43.9453 25.2559H39.6562C39.0738 25.2559 38.6016 25.7281 38.6016 26.3105C38.6016 26.893 39.0738 27.3652 39.6562 27.3652H43.9453C44.5278 27.3652 45 26.893 45 26.3105C45 25.7281 44.5278 25.2559 43.9453 25.2559Z" fill="white" />
                          <path d="M39.6781 13.6331C39.2664 13.2212 38.5986 13.2212 38.1866 13.6331L35.2034 16.6162C34.7916 17.028 34.7916 17.6959 35.2034 18.1078C35.6153 18.5196 36.2831 18.5196 36.695 18.1078L39.6781 15.1247C40.09 14.7129 40.09 14.045 39.6781 13.6331Z" fill="white" />
                          <path d="M27 8.31055C26.4175 8.31055 25.9453 8.78277 25.9453 9.36523V13.6543C25.9453 14.2368 26.4175 14.709 27 14.709C27.5825 14.709 28.0547 14.2368 28.0547 13.6543V9.36523C28.0547 8.78277 27.5825 8.31055 27 8.31055Z" fill="white" />
                          <path d="M26.9987 21.0371C26.5652 21.0371 26.1235 21.0891 25.6868 21.1914C23.8682 21.6159 22.3457 23.1129 21.8984 24.9165C21.7582 25.4818 22.1028 26.0538 22.6682 26.194C23.2336 26.3342 23.8055 25.9895 23.9457 25.4243C24.2032 24.3866 25.1162 23.4907 26.1671 23.2453C26.4471 23.1797 26.7269 23.1465 26.9987 23.1465C27.5812 23.1465 28.0534 22.6743 28.0534 22.0918C28.0534 21.5093 27.5812 21.0371 26.9987 21.0371Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17515_8861">
                            <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <h2 className="m-0">Our Approach</h2>
                    <ul className="p-0">
                      <li>
                        Practice identifying key details, understanding accents, and strengthening active listening skills.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="profile-tab-pane"
                role="tabpanel"
                aria-labelledby="profile-tab"
                tabIndex="0"
              >
                <div className="lets-coaching-tab-cards">
                  <div className="lets-coaching-tab-left-card">
                    <div className="card-img">
                      <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="54" height="52" rx="16" fill="#0286FF" />
                        <g clip-path="url(#clip0_17515_8851)">
                          <path d="M39.7308 13.5798C36.3328 10.1819 31.8116 8.31055 27 8.31055C22.1884 8.31055 17.6672 10.1819 14.2692 13.5798C10.8713 16.9776 9 21.4989 9 26.3105C9 31.1222 10.8713 35.6434 14.2692 39.0413C17.6671 42.4393 22.1884 44.3105 27 44.3105C31.8116 44.3105 36.3328 42.4392 39.7308 39.0413C43.1287 35.6435 45 31.1222 45 26.3105C45 21.4989 43.1287 16.9777 39.7308 13.5798ZM27 42.0837C18.3026 42.0837 11.2268 35.0079 11.2268 26.3105C11.2268 17.6132 18.3026 10.5374 27 10.5374C35.6974 10.5374 42.7732 17.6132 42.7732 26.3105C42.7732 35.0079 35.6974 42.0837 27 42.0837Z" fill="white" />
                          <path d="M35.7497 17.561C33.4143 15.2257 30.3069 13.9395 27.0001 13.9395C23.6932 13.9395 20.5858 15.2256 18.2504 17.561C15.915 19.8964 14.6289 23.0037 14.6289 26.3106C14.6289 29.6175 15.915 32.7248 18.2504 35.0602C20.5858 37.3956 23.6932 38.6818 27.0001 38.6818C30.3069 38.6818 33.4143 37.3956 35.7497 35.0602C38.0851 32.7248 39.3712 29.6175 39.3712 26.3106C39.3712 23.0037 38.0851 19.8964 35.7497 17.561ZM27.0001 36.455C21.4065 36.455 16.8557 31.9042 16.8557 26.3106C16.8557 20.717 21.4065 16.1663 27.0001 16.1663C32.5936 16.1663 37.1444 20.717 37.1444 26.3106C37.1444 31.9042 32.5936 36.455 27.0001 36.455Z" fill="white" />
                          <path d="M27.0001 19.5684C23.2823 19.5684 20.2578 22.593 20.2578 26.3106C20.2578 30.0283 23.2823 33.0528 27.0001 33.0528C30.7178 33.0528 33.7423 30.0283 33.7423 26.3106C33.7423 22.593 30.7178 19.5684 27.0001 19.5684ZM27.0001 30.826C24.5103 30.826 22.4846 28.8004 22.4846 26.3106C22.4846 23.8208 24.5103 21.7952 27.0001 21.7952C29.4898 21.7952 31.5155 23.8208 31.5155 26.3106C31.5155 28.8004 29.4898 30.826 27.0001 30.826Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17515_8851">
                            <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                          </clipPath>
                        </defs>
                      </svg>


                    </div>
                    <h2 className="m-0">What It Tests</h2>
                    <ul className="p-0">
                      <li>
                        Vocabulary comprehension, text analysis, and structure awareness.
                      </li>
                    </ul>
                  </div>
                  <div className="lets-coaching-tab-right-card">
                    <div className="card-img">
                      <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="54" height="52" rx="16" fill="#0286FF" />
                        <g clip-path="url(#clip0_17515_8861)">
                          <path d="M24.7284 17.0819C21.3516 17.8692 18.6332 20.5472 17.8031 23.9044C16.9704 27.2723 17.9234 30.7051 20.3526 33.0873C21.2118 33.93 21.7248 35.2806 21.7248 36.7003V36.9269C21.7248 37.8618 22.1327 38.703 22.7795 39.2827V41.1456C22.7795 42.8903 24.1989 44.3097 25.9436 44.3097H28.053C29.7976 44.3097 31.217 42.8903 31.217 41.1456V39.2827C31.8638 38.703 32.2717 37.8618 32.2717 36.9269V36.6961C32.2717 35.298 32.8122 33.9217 33.7176 33.0145C35.5057 31.2224 36.4905 28.8413 36.4905 26.3097C36.4905 20.2573 30.8817 15.6476 24.7284 17.0819ZM29.1077 41.1456C29.1077 41.7272 28.6345 42.2003 28.053 42.2003H25.9436C25.362 42.2003 24.8889 41.7272 24.8889 41.1456V40.0909H29.1077V41.1456ZM32.2243 31.5245C30.9139 32.8377 30.1623 34.7227 30.1623 36.6961V36.9269C30.1623 37.5084 29.6892 37.9816 29.1077 37.9816H24.8889C24.3073 37.9816 23.8342 37.5084 23.8342 36.9269V36.7003C23.8342 34.6964 23.1035 32.8306 21.8294 31.5812C19.9387 29.7271 19.1991 27.0466 19.8507 24.4107C20.4923 21.8157 22.595 19.7452 25.2074 19.1362C30.0359 18.0103 34.3811 21.6148 34.3811 26.3097C34.3811 28.2787 33.6151 30.1307 32.2243 31.5245Z" fill="white" />
                          <path d="M18.7953 16.6162L15.8122 13.6331C15.4004 13.2212 14.7325 13.2212 14.3206 13.6331C13.9087 14.045 13.9087 14.7128 14.3206 15.1247L17.3038 18.1078C17.7156 18.5196 18.3835 18.5196 18.7953 18.1078C19.2072 17.6959 19.2072 17.0281 18.7953 16.6162Z" fill="white" />
                          <path d="M14.3438 25.2559H10.0547C9.47222 25.2559 9 25.7281 9 26.3105C9 26.893 9.47222 27.3652 10.0547 27.3652H14.3438C14.9262 27.3652 15.3984 26.893 15.3984 26.3105C15.3984 25.7281 14.9262 25.2559 14.3438 25.2559Z" fill="white" />
                          <path d="M43.9453 25.2559H39.6562C39.0738 25.2559 38.6016 25.7281 38.6016 26.3105C38.6016 26.893 39.0738 27.3652 39.6562 27.3652H43.9453C44.5278 27.3652 45 26.893 45 26.3105C45 25.7281 44.5278 25.2559 43.9453 25.2559Z" fill="white" />
                          <path d="M39.6781 13.6331C39.2664 13.2212 38.5986 13.2212 38.1866 13.6331L35.2034 16.6162C34.7916 17.028 34.7916 17.6959 35.2034 18.1078C35.6153 18.5196 36.2831 18.5196 36.695 18.1078L39.6781 15.1247C40.09 14.7129 40.09 14.045 39.6781 13.6331Z" fill="white" />
                          <path d="M27 8.31055C26.4175 8.31055 25.9453 8.78277 25.9453 9.36523V13.6543C25.9453 14.2368 26.4175 14.709 27 14.709C27.5825 14.709 28.0547 14.2368 28.0547 13.6543V9.36523C28.0547 8.78277 27.5825 8.31055 27 8.31055Z" fill="white" />
                          <path d="M26.9987 21.0371C26.5652 21.0371 26.1235 21.0891 25.6868 21.1914C23.8682 21.6159 22.3457 23.1129 21.8984 24.9165C21.7582 25.4818 22.1028 26.0538 22.6682 26.194C23.2336 26.3342 23.8055 25.9895 23.9457 25.4243C24.2032 24.3866 25.1162 23.4907 26.1671 23.2453C26.4471 23.1797 26.7269 23.1465 26.9987 23.1465C27.5812 23.1465 28.0534 22.6743 28.0534 22.0918C28.0534 21.5093 27.5812 21.0371 26.9987 21.0371Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17515_8861">
                            <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <h2 className="m-0">Our Approach</h2>
                    <ul className="p-0">
                      <li>
                        Time management techniques, sentence reordering, and vocabulary-building exercises.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="write-tab-pane"
                role="tabpanel"
                aria-labelledby="write-tab"
                tabIndex="0"
              >
                <div className="lets-coaching-tab-cards">
                  <div className="lets-coaching-tab-left-card">
                    <div className="card-img">
                      <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="54" height="52" rx="16" fill="#0286FF" />
                        <g clip-path="url(#clip0_17515_8851)">
                          <path d="M39.7308 13.5798C36.3328 10.1819 31.8116 8.31055 27 8.31055C22.1884 8.31055 17.6672 10.1819 14.2692 13.5798C10.8713 16.9776 9 21.4989 9 26.3105C9 31.1222 10.8713 35.6434 14.2692 39.0413C17.6671 42.4393 22.1884 44.3105 27 44.3105C31.8116 44.3105 36.3328 42.4392 39.7308 39.0413C43.1287 35.6435 45 31.1222 45 26.3105C45 21.4989 43.1287 16.9777 39.7308 13.5798ZM27 42.0837C18.3026 42.0837 11.2268 35.0079 11.2268 26.3105C11.2268 17.6132 18.3026 10.5374 27 10.5374C35.6974 10.5374 42.7732 17.6132 42.7732 26.3105C42.7732 35.0079 35.6974 42.0837 27 42.0837Z" fill="white" />
                          <path d="M35.7497 17.561C33.4143 15.2257 30.3069 13.9395 27.0001 13.9395C23.6932 13.9395 20.5858 15.2256 18.2504 17.561C15.915 19.8964 14.6289 23.0037 14.6289 26.3106C14.6289 29.6175 15.915 32.7248 18.2504 35.0602C20.5858 37.3956 23.6932 38.6818 27.0001 38.6818C30.3069 38.6818 33.4143 37.3956 35.7497 35.0602C38.0851 32.7248 39.3712 29.6175 39.3712 26.3106C39.3712 23.0037 38.0851 19.8964 35.7497 17.561ZM27.0001 36.455C21.4065 36.455 16.8557 31.9042 16.8557 26.3106C16.8557 20.717 21.4065 16.1663 27.0001 16.1663C32.5936 16.1663 37.1444 20.717 37.1444 26.3106C37.1444 31.9042 32.5936 36.455 27.0001 36.455Z" fill="white" />
                          <path d="M27.0001 19.5684C23.2823 19.5684 20.2578 22.593 20.2578 26.3106C20.2578 30.0283 23.2823 33.0528 27.0001 33.0528C30.7178 33.0528 33.7423 30.0283 33.7423 26.3106C33.7423 22.593 30.7178 19.5684 27.0001 19.5684ZM27.0001 30.826C24.5103 30.826 22.4846 28.8004 22.4846 26.3106C22.4846 23.8208 24.5103 21.7952 27.0001 21.7952C29.4898 21.7952 31.5155 23.8208 31.5155 26.3106C31.5155 28.8004 29.4898 30.826 27.0001 30.826Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17515_8851">
                            <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                          </clipPath>
                        </defs>
                      </svg>


                    </div>
                    <h2 className="m-0">What It Tests</h2>
                    <ul className="p-0">
                      <li>
                        Essay composition, grammar accuracy, and passage summarization.
                      </li>
                    </ul>
                  </div>
                  <div className="lets-coaching-tab-right-card">
                    <div className="card-img">
                      <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="54" height="52" rx="16" fill="#0286FF" />
                        <g clip-path="url(#clip0_17515_8861)">
                          <path d="M24.7284 17.0819C21.3516 17.8692 18.6332 20.5472 17.8031 23.9044C16.9704 27.2723 17.9234 30.7051 20.3526 33.0873C21.2118 33.93 21.7248 35.2806 21.7248 36.7003V36.9269C21.7248 37.8618 22.1327 38.703 22.7795 39.2827V41.1456C22.7795 42.8903 24.1989 44.3097 25.9436 44.3097H28.053C29.7976 44.3097 31.217 42.8903 31.217 41.1456V39.2827C31.8638 38.703 32.2717 37.8618 32.2717 36.9269V36.6961C32.2717 35.298 32.8122 33.9217 33.7176 33.0145C35.5057 31.2224 36.4905 28.8413 36.4905 26.3097C36.4905 20.2573 30.8817 15.6476 24.7284 17.0819ZM29.1077 41.1456C29.1077 41.7272 28.6345 42.2003 28.053 42.2003H25.9436C25.362 42.2003 24.8889 41.7272 24.8889 41.1456V40.0909H29.1077V41.1456ZM32.2243 31.5245C30.9139 32.8377 30.1623 34.7227 30.1623 36.6961V36.9269C30.1623 37.5084 29.6892 37.9816 29.1077 37.9816H24.8889C24.3073 37.9816 23.8342 37.5084 23.8342 36.9269V36.7003C23.8342 34.6964 23.1035 32.8306 21.8294 31.5812C19.9387 29.7271 19.1991 27.0466 19.8507 24.4107C20.4923 21.8157 22.595 19.7452 25.2074 19.1362C30.0359 18.0103 34.3811 21.6148 34.3811 26.3097C34.3811 28.2787 33.6151 30.1307 32.2243 31.5245Z" fill="white" />
                          <path d="M18.7953 16.6162L15.8122 13.6331C15.4004 13.2212 14.7325 13.2212 14.3206 13.6331C13.9087 14.045 13.9087 14.7128 14.3206 15.1247L17.3038 18.1078C17.7156 18.5196 18.3835 18.5196 18.7953 18.1078C19.2072 17.6959 19.2072 17.0281 18.7953 16.6162Z" fill="white" />
                          <path d="M14.3438 25.2559H10.0547C9.47222 25.2559 9 25.7281 9 26.3105C9 26.893 9.47222 27.3652 10.0547 27.3652H14.3438C14.9262 27.3652 15.3984 26.893 15.3984 26.3105C15.3984 25.7281 14.9262 25.2559 14.3438 25.2559Z" fill="white" />
                          <path d="M43.9453 25.2559H39.6562C39.0738 25.2559 38.6016 25.7281 38.6016 26.3105C38.6016 26.893 39.0738 27.3652 39.6562 27.3652H43.9453C44.5278 27.3652 45 26.893 45 26.3105C45 25.7281 44.5278 25.2559 43.9453 25.2559Z" fill="white" />
                          <path d="M39.6781 13.6331C39.2664 13.2212 38.5986 13.2212 38.1866 13.6331L35.2034 16.6162C34.7916 17.028 34.7916 17.6959 35.2034 18.1078C35.6153 18.5196 36.2831 18.5196 36.695 18.1078L39.6781 15.1247C40.09 14.7129 40.09 14.045 39.6781 13.6331Z" fill="white" />
                          <path d="M27 8.31055C26.4175 8.31055 25.9453 8.78277 25.9453 9.36523V13.6543C25.9453 14.2368 26.4175 14.709 27 14.709C27.5825 14.709 28.0547 14.2368 28.0547 13.6543V9.36523C28.0547 8.78277 27.5825 8.31055 27 8.31055Z" fill="white" />
                          <path d="M26.9987 21.0371C26.5652 21.0371 26.1235 21.0891 25.6868 21.1914C23.8682 21.6159 22.3457 23.1129 21.8984 24.9165C21.7582 25.4818 22.1028 26.0538 22.6682 26.194C23.2336 26.3342 23.8055 25.9895 23.9457 25.4243C24.2032 24.3866 25.1162 23.4907 26.1671 23.2453C26.4471 23.1797 26.7269 23.1465 26.9987 23.1465C27.5812 23.1465 28.0534 22.6743 28.0534 22.0918C28.0534 21.5093 27.5812 21.0371 26.9987 21.0371Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17515_8861">
                            <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <h2 className="m-0">Our Approach</h2>
                    <ul className="p-0">
                      <li>
                        Proven templates, grammar refinement, and summarizing strategies to make every word count.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade show active"
                id="speak-tab-pane"
                role="tabpanel"
                aria-labelledby="speak-tab"
                tabIndex="0"
              >
                <div className="lets-coaching-tab-cards">

                  <div className="lets-coaching-tab-left-card">
                    <div className="card-img">
                      <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="54" height="52" rx="16" fill="#0286FF" />
                        <g clip-path="url(#clip0_17515_8851)">
                          <path d="M39.7308 13.5798C36.3328 10.1819 31.8116 8.31055 27 8.31055C22.1884 8.31055 17.6672 10.1819 14.2692 13.5798C10.8713 16.9776 9 21.4989 9 26.3105C9 31.1222 10.8713 35.6434 14.2692 39.0413C17.6671 42.4393 22.1884 44.3105 27 44.3105C31.8116 44.3105 36.3328 42.4392 39.7308 39.0413C43.1287 35.6435 45 31.1222 45 26.3105C45 21.4989 43.1287 16.9777 39.7308 13.5798ZM27 42.0837C18.3026 42.0837 11.2268 35.0079 11.2268 26.3105C11.2268 17.6132 18.3026 10.5374 27 10.5374C35.6974 10.5374 42.7732 17.6132 42.7732 26.3105C42.7732 35.0079 35.6974 42.0837 27 42.0837Z" fill="white" />
                          <path d="M35.7497 17.561C33.4143 15.2257 30.3069 13.9395 27.0001 13.9395C23.6932 13.9395 20.5858 15.2256 18.2504 17.561C15.915 19.8964 14.6289 23.0037 14.6289 26.3106C14.6289 29.6175 15.915 32.7248 18.2504 35.0602C20.5858 37.3956 23.6932 38.6818 27.0001 38.6818C30.3069 38.6818 33.4143 37.3956 35.7497 35.0602C38.0851 32.7248 39.3712 29.6175 39.3712 26.3106C39.3712 23.0037 38.0851 19.8964 35.7497 17.561ZM27.0001 36.455C21.4065 36.455 16.8557 31.9042 16.8557 26.3106C16.8557 20.717 21.4065 16.1663 27.0001 16.1663C32.5936 16.1663 37.1444 20.717 37.1444 26.3106C37.1444 31.9042 32.5936 36.455 27.0001 36.455Z" fill="white" />
                          <path d="M27.0001 19.5684C23.2823 19.5684 20.2578 22.593 20.2578 26.3106C20.2578 30.0283 23.2823 33.0528 27.0001 33.0528C30.7178 33.0528 33.7423 30.0283 33.7423 26.3106C33.7423 22.593 30.7178 19.5684 27.0001 19.5684ZM27.0001 30.826C24.5103 30.826 22.4846 28.8004 22.4846 26.3106C22.4846 23.8208 24.5103 21.7952 27.0001 21.7952C29.4898 21.7952 31.5155 23.8208 31.5155 26.3106C31.5155 28.8004 29.4898 30.826 27.0001 30.826Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17515_8851">
                            <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                          </clipPath>
                        </defs>
                      </svg>


                    </div>
                    <h2 className="m-0">What It Tests</h2>
                    <ul className="p-0">
                      <li>
                        Pronunciation, fluency, and verbal clarity.
                      </li>
                    </ul>
                  </div>
                  <div className="lets-coaching-tab-right-card">
                    <div className="card-img">
                      <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="54" height="52" rx="16" fill="#0286FF" />
                        <g clip-path="url(#clip0_17515_8861)">
                          <path d="M24.7284 17.0819C21.3516 17.8692 18.6332 20.5472 17.8031 23.9044C16.9704 27.2723 17.9234 30.7051 20.3526 33.0873C21.2118 33.93 21.7248 35.2806 21.7248 36.7003V36.9269C21.7248 37.8618 22.1327 38.703 22.7795 39.2827V41.1456C22.7795 42.8903 24.1989 44.3097 25.9436 44.3097H28.053C29.7976 44.3097 31.217 42.8903 31.217 41.1456V39.2827C31.8638 38.703 32.2717 37.8618 32.2717 36.9269V36.6961C32.2717 35.298 32.8122 33.9217 33.7176 33.0145C35.5057 31.2224 36.4905 28.8413 36.4905 26.3097C36.4905 20.2573 30.8817 15.6476 24.7284 17.0819ZM29.1077 41.1456C29.1077 41.7272 28.6345 42.2003 28.053 42.2003H25.9436C25.362 42.2003 24.8889 41.7272 24.8889 41.1456V40.0909H29.1077V41.1456ZM32.2243 31.5245C30.9139 32.8377 30.1623 34.7227 30.1623 36.6961V36.9269C30.1623 37.5084 29.6892 37.9816 29.1077 37.9816H24.8889C24.3073 37.9816 23.8342 37.5084 23.8342 36.9269V36.7003C23.8342 34.6964 23.1035 32.8306 21.8294 31.5812C19.9387 29.7271 19.1991 27.0466 19.8507 24.4107C20.4923 21.8157 22.595 19.7452 25.2074 19.1362C30.0359 18.0103 34.3811 21.6148 34.3811 26.3097C34.3811 28.2787 33.6151 30.1307 32.2243 31.5245Z" fill="white" />
                          <path d="M18.7953 16.6162L15.8122 13.6331C15.4004 13.2212 14.7325 13.2212 14.3206 13.6331C13.9087 14.045 13.9087 14.7128 14.3206 15.1247L17.3038 18.1078C17.7156 18.5196 18.3835 18.5196 18.7953 18.1078C19.2072 17.6959 19.2072 17.0281 18.7953 16.6162Z" fill="white" />
                          <path d="M14.3438 25.2559H10.0547C9.47222 25.2559 9 25.7281 9 26.3105C9 26.893 9.47222 27.3652 10.0547 27.3652H14.3438C14.9262 27.3652 15.3984 26.893 15.3984 26.3105C15.3984 25.7281 14.9262 25.2559 14.3438 25.2559Z" fill="white" />
                          <path d="M43.9453 25.2559H39.6562C39.0738 25.2559 38.6016 25.7281 38.6016 26.3105C38.6016 26.893 39.0738 27.3652 39.6562 27.3652H43.9453C44.5278 27.3652 45 26.893 45 26.3105C45 25.7281 44.5278 25.2559 43.9453 25.2559Z" fill="white" />
                          <path d="M39.6781 13.6331C39.2664 13.2212 38.5986 13.2212 38.1866 13.6331L35.2034 16.6162C34.7916 17.028 34.7916 17.6959 35.2034 18.1078C35.6153 18.5196 36.2831 18.5196 36.695 18.1078L39.6781 15.1247C40.09 14.7129 40.09 14.045 39.6781 13.6331Z" fill="white" />
                          <path d="M27 8.31055C26.4175 8.31055 25.9453 8.78277 25.9453 9.36523V13.6543C25.9453 14.2368 26.4175 14.709 27 14.709C27.5825 14.709 28.0547 14.2368 28.0547 13.6543V9.36523C28.0547 8.78277 27.5825 8.31055 27 8.31055Z" fill="white" />
                          <path d="M26.9987 21.0371C26.5652 21.0371 26.1235 21.0891 25.6868 21.1914C23.8682 21.6159 22.3457 23.1129 21.8984 24.9165C21.7582 25.4818 22.1028 26.0538 22.6682 26.194C23.2336 26.3342 23.8055 25.9895 23.9457 25.4243C24.2032 24.3866 25.1162 23.4907 26.1671 23.2453C26.4471 23.1797 26.7269 23.1465 26.9987 23.1465C27.5812 23.1465 28.0534 22.6743 28.0534 22.0918C28.0534 21.5093 27.5812 21.0371 26.9987 21.0371Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17515_8861">
                            <rect width="36" height="36" fill="white" transform="translate(9 8.31055)" />
                          </clipPath>
                        </defs>
                      </svg>

                    </div>
                    <h2 className="m-0">Our Approach</h2>
                    <ul className="p-0">
                      <li>
                        Confidence-building exercises, AI-assisted pronunciation tools, and fluency-enhancing techniques.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row master-all-footer">
            <div className="col-md-6">
              <div className="light-blue-box">
                By preparing with our section-specific resources, you'll maximize your overall score and achieve your Canadian immigration goals.
              </div>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <Link className="primary-btn" to="/auth/register">
                <span className="btn-inner">
                  ENROLL IN OUR PREPARATION PROGRAM <img src="/images/web-new-images/right-arrow-black.svg" alt="Register Now" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div> */}
        {/* <div className="pc-la pc-la-grid-section">
        <div className="container">
          <div className="pc-la-heading text-center">
            <h2 className="primary-heading fw-700">
              <span className="wpl-badge text-white">THE LANGUAGE <br /> ACADEMY ADVANTAGE</span>
              <br />
              COMPLETE PTE CORE PREPARATION SYSTEM
            </h2>
          </div>
          <div className="plan-cards pc-la-plan-cards">
            <div className="plan-card-outer">
              <div className="plan-card">
                <div className="icon-wrapper"><span>1</span></div>
                <div className="content-wrapper">
                  <h2>PTE CORE PRACTICE MATERIAL</h2>
                  <p>Experience the actual PTE Core test environment with our simulation technology that mirrors the real exam algorithms.</p>
                </div>
              </div>
            </div>
            <div className="plan-card-outer">
              <div className="plan-card">
                <div className="icon-wrapper"><span>2</span></div>
                <div className="content-wrapper">
                  <h2>DETAILED PERFORMANCE ANALYTICS</h2>
                  <p>Receive comprehensive score breakdowns showing exactly where you're losing points and how to improve.</p>
                </div>
              </div>
            </div>
            <div className="plan-card-outer">
              <div className="plan-card">
                <div className="icon-wrapper"><span>3</span></div>
                <div className="content-wrapper">
                  <h2>EXPERT PTE CORE PREPARATION GUIDANCE</h2>
                  <p>Learn from tutors who specialize in PTE Core Online Training.</p>
                </div>
              </div>
            </div>
            <div className="plan-card-outer">
              <div className="plan-card">
                <div className="icon-wrapper"><span>4</span></div>
                <div className="content-wrapper">
                  <h2>PROVEN STRATEGIES & TECHNIQUES</h2>
                  <p>Apply our time-tested PTE Core strategies and techniques specifically designed to maximize your scores.</p>
                </div>
              </div>
            </div>
            <div className="plan-card-outer">
              <div className="plan-card">
                <div className="icon-wrapper"><span>5</span></div>
                <div className="content-wrapper">
                  <h2>UNLIMITED PRACTICE ACCESS</h2>
                  <p>Practice 24/7 with our extensive PTE Core question bank covering all exam question types.</p>
                </div>
              </div>
            </div>
            <div className="plan-card-outer">
              <div className="plan-card">
                <div className="icon-wrapper"><span>6</span></div>
                <div className="content-wrapper">
                  <h2>PERSONALIZED PTE CORE COURSE PLANS</h2>
                  <p>Follow a customized preparation roadmap based on your strengths, weaknesses, and target scores.</p>
                </div>
              </div>
            </div>
            <div className="plan-card-outer">
              <div className="plan-card">
                <div className="icon-wrapper"><span>7</span></div>
                <div className="content-wrapper">
                  <h2>GUARANTEED RESULTS</h2>
                  <p>Our PTE Core mock tests and preparation system deliver consistent, proven outcomes.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="pc-la-footer">
            <div className="light-blue-box">95% of our students achieve their target scores within two attempts</div>
            <Link className="primary-btn" to="/auth/register">
              <span className="btn-inner">
                CREATE YOUR ACCOUNT <img src="/images/web-new-images/right-arrow-black.svg" alt="Register Now" />
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className="success-stories">
        <div className="container">
          <h2 className="primary-heading text-center">Student Success Stories</h2>
          <div className="success-stories-cards">
            <div className="success-stories-card">
              <div className="story-user-info">
                <div className="user-img">
                  <img src="/images/web-new-images/crack-user.png" alt="Image" />
                </div>
                <div>
                  <h4 className="user-name">- Rajesh K.</h4>
                  <h4 className="user-designation">Now in Toronto</h4>
                </div>
              </div>
              <div className="story-user-content">
                <p>After failing IELTS twice, I switched to PTE Core and scored the equivalent of CLB 9 on my first attempt using Language Academy's system. I received my ITA within 3 weeks!</p>
              </div>
            </div>
            <div className="success-stories-card">
              <div className="story-user-info">
                <div className="user-img">
                  <img src="/images/web-new-images/crack-user.png" alt="Image" />
                </div>
                <div>
                  <h4 className="user-name">- Maria L.</h4>
                  <h4 className="user-designation">Express Entry Applicant</h4>
                </div>
              </div>
              <div className="story-user-content">
                <p>The mock tests were incredibly accurate. My actual PTE Core score was only 2 points different from my final practice test. Now my PR application is in process!</p>
              </div>
            </div>
          </div>
          <div className="text-center">
            <Link className="primary-btn" to="/auth/register">
              <span className="btn-inner">
                BOOK YOUR PREPARATION SESSION <img src="/images/web-new-images/right-arrow-black.svg" alt="Register Now" />
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className="pc-register scoring-better-section">
        <div className="container">
          <h2 className="primary-heading text-center fw-700">
            <span className="wpl-badge pte-naati-badge">HOW TO REGISTER</span>
            <br /> FOR THE PTE CORE TEST
          </h2>
          <p className="sub-heading text-center">Follow these simple steps to book <br /> your official PTE Core exam</p>
          <div className="row">
            <div className="scoring-better-content">
              <p className="sub-title">
                Official Test Registration Process
              </p>
              <ul className="pc-register-list">
                <li><span className="count count1">1</span><span>Visit Pearson PTE's official website and click <strong>"Book a Test"</strong></span></li>
                <li><span className="count count2">2</span><span>Select your country and choose <strong>"PTE Core"</strong> from the test options</span></li>
                <li><span className="count count3">3</span>Browse available test centers and select your preferred location</li>
                <li><span className="count count4">4</span>Choose your test date and time from the calendar</li>
                <li><span className="count count5">5</span>Create an account or log in to your existing Pearson account</li>
                <li><span className="count count6">6</span>Provide identification details (passport recommended for immigration purposes)</li>
                <li><span className="count count7">7</span>Review your booking details and complete payment</li>
              </ul>
            </div>
            <div className="scoring-better-outer">
              <div className="scoring-better-img">
                <img src="/images/web-new-images/dashboard.jpg" alt="Image" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pc-important-info">
        <div className="container">
          <h2 className="primary-heading text-center">
            Important Information
          </h2>
          <div className="pc-important-tabs">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="home-tab1" data-bs-toggle="tab" data-bs-target="#home-tab-pane1" type="button" role="tab" aria-controls="home-tab-pane1" aria-selected="true"><h2><img src="/images/web-new-images/icons/dollar-icon.svg" alt="Register Now" /> Test Fees </h2>
                  <p>PTE Core fees vary by location but are expected to align with PTE Academic costs.</p>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="profile-tab1" data-bs-toggle="tab" data-bs-target="#profile-tab-pane1" type="button" role="tab" aria-controls="profile-tab-pane1" aria-selected="false"><h2><img src="/images/web-new-images/icons/user-icon.svg" alt="Register Now" /> Required ID</h2>
                  <p>Valid passport (recommended for immigration purposes)</p>
                </button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="home-tab-pane1" role="tabpanel1" aria-labelledby="home-tab1" tabIndex="0">
                <h2 className="tab-title"><img src="/images/web-new-images/icons/building-icon.svg" alt="Register Now" />  Test Centers around the World</h2>
                <div className="tabs-logos">
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/australia.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/brazil.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/canada.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/ivory-coast.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/south-africa.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/pakistan.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/india.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/indonesia.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/nepal.png" alt="logo" />
                  </div>
                </div>
                <div className="tab-pane-list light-offwhite-box">
                  <h2>Test Centers in <img className="heading-icon" src="/images/web-new-images/flages/australia.png" alt="logo" /> Australia</h2>
                  <ul>
                    <li><span className="circle"></span>Sydney CBD</li>
                    <li><span className="circle"></span>Melbourne Central</li>
                    <li><span className="circle"></span>Brisbane City</li>
                    <li><span className="circle"></span>Perth Metro</li>
                    <li><span className="circle"></span>Adelaide Central</li>
                  </ul>
                </div>
                <h2>Special Accommodations</h2>
                <p>Available for test-takers with disabilities (must be requested during registration).</p>
                <div className="light-offwhite-box">Need assistance with booking your test? Our support team can guide you through the process.</div>
              </div>
              <div className="tab-pane fade" id="profile-tab-pane1" role="tabpanel1" aria-labelledby="profile-tab1" tabIndex="0">
                <h2 className="tab-title"><img src="/images/web-new-images/icons/building-icon.svg" alt="Register Now" />  Test Centers around the World</h2>
                <div className="tabs-logos">
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/australia.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/brazil.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/canada.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/ivory-coast.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/south-africa.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/pakistan.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/india.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/indonesia.png" alt="logo" />
                  </div>
                  <div className="logo-wrapper">
                    <img src="/images/web-new-images/flages/nepal.png" alt="logo" />
                  </div>
                </div>
                <div className="tab-pane-list light-offwhite-box">
                  <h2>Test Centers in <img className="heading-icon" src="/images/web-new-images/flages/australia.png" alt="logo" /> Australia</h2>
                  <ul>
                    <li><span className="circle"></span>Sydney CBD</li>
                    <li><span className="circle"></span>Melbourne Central</li>
                    <li><span className="circle"></span>Brisbane City</li>
                    <li><span className="circle"></span>Perth Metro</li>
                    <li><span className="circle"></span>Adelaide Central</li>
                  </ul>
                </div>
                <h2>Special Accommodations</h2>
                <p>Available for test-takers with disabilities (must be requested during registration).</p>
                <div className="light-offwhite-box">Need assistance with booking your test? Our support team can guide you through the process.</div>
              </div>
            </div>
            <div className="text-center">
              <Link className="primary-btn" to="/auth/register">
                <span className="btn-inner">
                  SIGN UP FOR EXPERT GUIDANCE <img src="/images/web-new-images/right-arrow-black.svg" alt="Register Now" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="pc-journey-section">
        <div className="container">
          <div className="pc-journey-heading">
            <h2 className="primary-heading text-center text-white">START YOUR <span className="wpl-badge text-white">PTE CORE</span><br />PREPARATION JOURNEY TODAY</h2>
            <p className="sub-title text-center text-white">Don't leave your Canadian immigration journey to chance. Join thousands of successful test-takers who've achieved their target scores with Language Academy's comprehensive preparation system.</p>
          </div>
          <div className="journey-cards-content">
            <div className="score-once-cards">
              <div className="score-once-card card1">
                <h3 className="score-count">1</h3>
                <h4 className="sub-title">PLATFORM ACCESS</h4>
                <h2 className="score-title">Value <span>$999</span></h2>
                <p>Your Investment</p>
                <span className="score-once-btn"><span className="price-title">Starting <br /> Price</span><span className="price">$29</span></span>
              </div>
              <div className="score-once-card card2">
                <h3 className="score-count">2</h3>
                <h4 className="sub-title">ONLINE COACHING</h4>
                <h2 className="score-title">Value <span>$2,495</span></h2>
                <p>Your Investment</p>
                <span className="score-once-btn"><span className="price-title">Starting <br /> Price</span><span className="price">$460</span></span>
              </div>
              <div className="score-once-card card3">
                <h3 className="score-count">3</h3>
                <h4 className="sub-title">CAMPUS COACHING</h4>
                <h2 className="score-title">Value <span>$3,995</span></h2>
                <p>Your Investment</p>
                <span className="score-once-btn"><span className="price-title">Starting <br /> Price</span><span className="price">$695</span></span>
              </div>
            </div>
            <br />
            <div className="light-blue-box blue-box">
              The question isn't whether you can afford proper preparation, it's whether you can afford to keep failing without it.
            </div>
            <br />
            <br />
            <div className="text-center">
              <Link className="primary-btn" to="/auth/register">
                <span className="btn-inner">
                  CLAIM YOUR SPOT <img src="/images/web-new-images/right-arrow-black.svg" alt="Register Now" />
                </span>
              </Link>
            </div>
            <div className="downlaodnow-row">
              <div className="downlaodnow-content">
                <h2>PTE APP</h2>
                <p>
                  Download our NA CCL App
                  <br />
                  from App Store and Play Store
                </p>
              </div>
              <div className="downlaodnow-img">
                <img
                  src="/images/web-new-images/welcome-img.png"
                  alt="Register Now"
                />
              </div>
              <div className="downlaodnow-third-col">
                <h3 className="downlaodnow-title">Download Now!</h3>
                <div className="downlaodnow-btns">
                  <a target="_blank" href="https://play.google.com/store/apps/details?id=com.languageacademy" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a target="_blank" href="https://apps.apple.com/au/app/la-pte/id6443614190" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="faq-section">
        <div className="container">
          <div className="row">
            <h2 className="secondary-heading text-center">
              Frequently Asked Questions
            </h2>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    How many PTE Core practice tests should I take for optimal preparation?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    We recommend taking at least three complete PTE core Academic Practice Tests using our Free PTE Core Practice material to familiarize yourself with the pte core exam pattern.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    What is the PTE Core requirement for Canadian immigration?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Requirements vary based on immigration programs, consult your program's specific guidelines for score thresholds. Express Entry typically requires scores equivalent to CLB 7-9 depending on your program category.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    What is the duration of a PTE Core mock test?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Each mock test takes approximately 3 hours, mirroring the actual exam.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    How is PTE Core different from other English tests?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Unlike IELTS and CELPIP, PTE Core uses AI scoring for unbiased results and delivers scores within 24 hours. The test is fully digital and offers more flexible scheduling options.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    Do you offer personalized PTE Core preparation coaching?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Yes, our PTE Core Online Training experts provide personalized feedback and PTE Core Course sessions with comprehensive PTE Core resources.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSix">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    How quickly can I improve my score with your PTE Core preparation?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Most students see significant improvement within 2-3 weeks of dedicated practice with our PTE Core Practice Website and Free Online PTE Core Practice platform.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSeven">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven"
                    aria-expanded="false"
                    aria-controls="collapseSeven"
                  >
                    Is there a limit to how many times I can take PTE Core?
                  </button>
                </h2>
                <div
                  id="collapseSeven"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSeven"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    No, you can take the test as many times as needed, with only a 5-day waiting period between attempts.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default PteCore;
